import {
  __export,
  __name,
  __privateAdd,
  __privateGet,
  __privateSet,
  __publicField
} from "./chunk-Z3TMLQTO.js";

// src/domain/constants/cache.ts
var encode = /* @__PURE__ */ __name((data) => {
  return Buffer.from(data).toString("base64");
}, "encode");
var decode = /* @__PURE__ */ __name((data) => {
  return Buffer.from(data, "base64").toString();
}, "decode");
var REGISTRO = {
  CREATED: "registry.created",
  UPDATED: "registry.updated",
  DELETED: "registry.deleted",
  ALL: "registry.*"
};
var ABONO = {
  CREATED: "allowance.created",
  UPDATED: "allowance.updated",
  DELETED: "allowance.deleted",
  ALL: "allowance.*"
};
var AFASTAMENTO = {
  CREATED: "absence.created",
  UPDATED: "absence.updated",
  DELETED: "absence.deleted",
  ALL: "absence.*"
};
var COMPENSACAO = {
  CREATED: "compensation.created",
  UPDATED: "compensation.updated",
  DELETED: "compensation.deleted",
  ALL: "compensation.*"
};
var FUNCIONARIO = {
  CREATED: "funcionario.created",
  UPDATED: "funcionario.updated",
  DELETED: "funcionario.deleted",
  ALL: "funcionario.*"
};
var CALCULO = {
  CREATED: "calculo.created"
};
var EVENTS = {
  REGISTRO,
  ABONO,
  AFASTAMENTO,
  COMPENSACAO,
  FUNCIONARIO,
  CALCULO
};
function cacheKey(arg1, arg2, arg3) {
  if (typeof arg1 === "string" && arg2 === void 0 && arg3 === void 0) {
    const [, listenerEncoded2, query] = arg1.split(":");
    const [nomeFantasia, id] = decode(listenerEncoded2);
    const params2 = queryParamsToRecord(query);
    return {
      listener: {
        nomeFantasia,
        id: +id
      },
      competencia: params2.competencia,
      funcionarioId: params2.funcionarioId
    };
  }
  const params = recordToQueryParams({
    competencia: arg2,
    funcionarioId: arg3
  });
  if (typeof arg1 === "object") {
    const { id, nomeFantasia } = arg1;
    const listener = listenerEncoded(nomeFantasia, id);
    return `registry:${listener}:${params}`;
  }
  return `registry:${arg1}:${params}`;
}
__name(cacheKey, "cacheKey");
var listenerEncoded = /* @__PURE__ */ __name((nomeFantasia, id) => {
  const nome = nomeFantasia.split(" ")[0].toLowerCase();
  return encode(`${nome}:${id}`);
}, "listenerEncoded");
function recordToQueryParams(params) {
  return Object.entries(params).map(([key, value]) => {
    if (value instanceof Array) {
      return `${key}=${value.join(",")}`;
    }
    if (value instanceof Date) {
      return `${key}=${value.toISOString()}`;
    }
    return `${key}=${value}`;
  }).join("&");
}
__name(recordToQueryParams, "recordToQueryParams");
function queryParamsToRecord(params) {
  const entries = params.split("&");
  const result = entries.reduce((acc, entry) => {
    const [key, value] = entry.split("=");
    if (value.includes(",")) {
      acc[key] = value.split(",");
    }
    if (value.includes("-")) {
      const [ano, mes, dia] = value.split("-");
      if (!ano || !mes || !dia) {
        throw new Error("Invalid date");
      }
      acc[key] = /* @__PURE__ */ new Date(`${ano}-${mes}-${dia}`);
    }
    return acc;
  }, {});
  return result;
}
__name(queryParamsToRecord, "queryParamsToRecord");

// src/domain/constants/enums.ts
var Conexao = {
  Local: "Local",
  Web: "Web"
};
var Sexo = {
  M: "M",
  F: "F"
};
var Status = {
  PENDENTE: "PENDENTE",
  PROCESSANDO: "PROCESSANDO",
  CONCLUIDO: "CONCLUIDO",
  INCOMPLETO: "INCOMPLETO",
  ERRO: "ERRO"
};
var StatusAprovacao = {
  PENDENTE: "PENDENTE",
  APROVADO: "APROVADO",
  REPROVADO: "REPROVADO",
  PENDENTE_EXCLUSAO: "PENDENTE_EXCLUSAO"
};
var StatusCompetencia = {
  ABERTA: "ABERTA",
  FECHADA: "FECHADA"
};
var TipoSaldo = {
  HORAS_EXTRAS: "Horas extras",
  HORAS_FALTAS: "Falta em horas",
  VALE_ALIMENTACAO: "Vale alimenta\xE7\xE3o"
};
var LayoutFolha = {
  DOMINIO: "DOMINIO",
  DOMINIO_DECIMAL: "DOMINIO_DECIMAL",
  FORTES_5: "FORTES_5",
  FORTES_6: "FORTES_6",
  QUESTOR_01: "QUESTOR_01",
  QUESTOR_02: "QUESTOR_02",
  QUESTOR_03: "QUESTOR_03",
  SYSTEM: "SYSTEM",
  DATA_CEMPRO: "DATA_CEMPRO",
  VIASOFT: "VIASOFT"
};
var OpcoesExportacaoFolha = {
  NADA: 1,
  PAGAR: 2,
  DESCONTAR: 3
};
var TipoDescontoDSR = {
  NAO_DESCONTAR: "NAO_DESCONTAR",
  FALTA_INTEGRAL: "FALTA_INTEGRAL",
  TURNO: "TURNO",
  ATRASO: "ATRASO"
};
var TipoCliente = {
  EM_AVALIACAO: "Em avalia\xE7\xE3o",
  PENDENTE: "Pendente",
  CLIENTE: "Cliente",
  INATIVO: "Inativo",
  CANCELADO: "Cancelado",
  REPRESENTANTE: "Representante"
};
var TipoOcorrencia = {
  AFASTAMENTO: "AFASTAMENTO",
  COMPENSACAO: "COMPENSACAO",
  AMAMENTACAO: "AMAMENTACAO",
  FOLGA: "FOLGA"
};
var TipoCompensacaoDia = {
  FERIADO: "FERIADO",
  FOLGA: "FOLGA"
};
var TipoCompensacaoManual = {
  COMPENSAR: "COMPENSAR",
  COMPENSADO: "COMPENSADO",
  MESMO_DIA: "MESMO_DIA"
};
var OrigemFaltaCadastrada = /* @__PURE__ */ function(OrigemFaltaCadastrada2) {
  OrigemFaltaCadastrada2[OrigemFaltaCadastrada2["AUTOMATICA"] = 2] = "AUTOMATICA";
  OrigemFaltaCadastrada2[OrigemFaltaCadastrada2["MANUAL"] = 1] = "MANUAL";
  return OrigemFaltaCadastrada2;
}({});

// src/domain/logic/Maybe.ts
var _value, _a;
var MaybeEntity = (_a = class {
  constructor(value) {
    __privateAdd(this, _value);
    __privateSet(this, _value, value);
  }
  static from(value, ...values) {
    for (const val of [
      value,
      ...values
    ]) {
      if (_a.isSome(val)) return new _a(val);
    }
    return new _a(null);
  }
  isSome() {
    return _a.isSome(__privateGet(this, _value));
  }
  isNone() {
    return _a.isNone(__privateGet(this, _value));
  }
  get value() {
    return _a.getValue(__privateGet(this, _value));
  }
  getOrElse(defaultValue) {
    return _a.getOrElse(__privateGet(this, _value), defaultValue);
  }
  /**
   * Se o valor existe, aplica a função e o retorna, caso contrário, retorna `null`
   * @see MaybeEntity.optionalMap
   */
  map(fn) {
    return _a.map(__privateGet(this, _value), fn);
  }
  /**
   * Se o valor existe, aplica a função e o retorna, caso contrário, retorna `undefined`
   * @see MaybeEntity.map
   */
  optionalMap(fn) {
    return _a.optionalMap(__privateGet(this, _value), fn);
  }
  /**
   * Se o valor existe, aplica a função e o retorna, caso contrário, retorna `null`
   * @see MaybeEntity.map
   */
  nullishMap(fn) {
    return _a.optionalMap(__privateGet(this, _value), fn, null);
  }
  mapOrElse(fn, defaultValue) {
    return _a.mapOrElse(__privateGet(this, _value), fn, defaultValue);
  }
  static isSome(value) {
    if (value === null) return false;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === "object") return JSON.stringify(value) !== "{}";
    return value !== void 0;
  }
  static isNone(value) {
    return !_a.isSome(value);
  }
  static getValue(value) {
    if (_a.isNone(value)) {
      throw new Error("Cannot get value of None");
    }
    return value;
  }
  static getOrElse(value, defaultValue) {
    return _a.isSome(value) ? value : defaultValue();
  }
  static map(value, fn) {
    return _a.isSome(value) ? fn(value) : null;
  }
  static optionalMap(value, fn, fallback) {
    if (_a.isSome(value)) return fn(value);
    return typeof fallback !== "undefined" ? fallback : void 0;
  }
  static mapOrElse(value, fn, defaultValue) {
    if (_a.isNone(value)) return defaultValue();
    const result = fn(value);
    if (Maybe.isSome(result)) return result;
    return defaultValue();
  }
}, _value = new WeakMap(), __name(_a, "MaybeEntity"), _a);
function Maybe(value, ...values) {
  return MaybeEntity.from(value, ...values);
}
__name(Maybe, "Maybe");
Maybe.from = MaybeEntity.from;
Maybe.isSome = MaybeEntity.isSome;
Maybe.isNone = MaybeEntity.isNone;
Maybe.getValue = MaybeEntity.getValue;
Maybe.getOrElse = MaybeEntity.getOrElse;
Maybe.map = MaybeEntity.map;
Maybe.optionalMap = MaybeEntity.optionalMap;
Maybe.mapOrElse = MaybeEntity.mapOrElse;

// src/domain/logic/Either.ts
var _Left = class _Left {
  constructor(value) {
    __publicField(this, "value");
    this.value = value;
  }
  isLeft() {
    return true;
  }
  isRight() {
    return false;
  }
};
__name(_Left, "Left");
var Left = _Left;
var _Right = class _Right {
  constructor(value) {
    __publicField(this, "value");
    this.value = value;
  }
  isLeft() {
    return false;
  }
  isRight() {
    return true;
  }
};
__name(_Right, "Right");
var Right = _Right;
var left = /* @__PURE__ */ __name((l) => {
  return new Left(l);
}, "left");
var right = /* @__PURE__ */ __name((a) => {
  return new Right(a);
}, "right");

// src/types/SN.ts
var _value2, _a2;
var ValueObject = (_a2 = class {
  constructor(value) {
    __privateAdd(this, _value2);
    __privateSet(this, _value2, value);
  }
  static from(value) {
    return new _a2(value);
  }
  static isTrue(value) {
    if (typeof value === "boolean") return value;
    return value === "S";
  }
  isTrue(condition) {
    if (Maybe.isNone(condition)) return _a2.isTrue(__privateGet(this, _value2));
    return _a2.isTrue(condition);
  }
  static isFalse(value) {
    return !_a2.isTrue(value);
  }
  isFalse(condition) {
    if (Maybe.isNone(condition)) return _a2.isFalse(__privateGet(this, _value2));
    return _a2.isFalse(condition);
  }
  /**
   * Formata o valor para 'Sim' ou 'Não'
   * @param force retorna 'Não' mesmo se o valor não for S|N
   * @example
   * ```ts
   * SN.format('S') // 'Sim'
   * SN.format('') // ''
   * SN.format('', true) // 'Não'
   * ```
   */
  static format(value, force = false) {
    if (force) return _a2.isTrue(value) ? "Sim" : "N\xE3o";
    if (!value) return value;
    return _a2.isTrue(value) ? "Sim" : "N\xE3o";
  }
  format(force) {
    return _a2.format(__privateGet(this, _value2), force);
  }
}, _value2 = new WeakMap(), __name(_a2, "ValueObject"), _a2);
var TypeSN = {
  S: "S",
  N: "N"
};
function SN(value) {
  return ValueObject.from(value);
}
__name(SN, "SN");
SN.from = ValueObject.from;
SN.isTrue = ValueObject.isTrue;
SN.isFalse = ValueObject.isFalse;
SN.format = ValueObject.format;
SN.N = TypeSN.N;
SN.S = TypeSN.S;

// src/domain/utils/banco-horas.ts
function bancoAtivo(regra, competencia) {
  if (!regra) throw new Error("Regra de c\xE1lculo n\xE3o encontrada");
  if (SN.isFalse(regra.controlarBancoHoras)) return false;
  const inicio = regra.inicioBancoHoras;
  const fim = regra.fimBancoHoras;
  if (inicio && competencia < inicio) return false;
  if (fim && competencia > fim) return false;
  return true;
}
__name(bancoAtivo, "bancoAtivo");

// src/domain/utils/compactarHorarios.ts
import { groupBy } from "@acme/common";
var diasSemana = [
  "Segunda",
  "Ter\xE7a",
  "Quarta",
  "Quinta",
  "Sexta",
  "S\xE1bado",
  "Domingo"
];
var diasSliced = diasSemana.map((d) => d.slice(0, 3));
function compactarSequenciaDias(dias) {
  if (dias.length === 0) return "";
  if (dias.length === 1) return dias[0];
  const indices = dias.map((dia) => diasSliced.indexOf(dia)).filter((index) => index !== -1).sort((a, b) => a - b);
  if (indices.length === 7) return "Todos";
  const sequencias = [];
  let sequenciaAtual = [
    indices[0]
  ];
  for (let i = 1; i < indices.length; i++) {
    if (indices[i] === indices[i - 1] + 1) {
      sequenciaAtual.push(indices[i]);
    } else {
      sequencias.push(sequenciaAtual);
      sequenciaAtual = [
        indices[i]
      ];
    }
  }
  sequencias.push(sequenciaAtual);
  const formatadas = sequencias.map((seq) => {
    if (seq.length >= 3) {
      return `${diasSliced[seq[0]]} a ${diasSliced[seq[seq.length - 1]]}`;
    } else if (seq.length === 2) {
      return `${diasSliced[seq[0]]} e ${diasSliced[seq[1]]}`;
    } else {
      return diasSliced[seq[0]];
    }
  });
  if (formatadas.length === 1) return formatadas[0];
  if (formatadas.length === 2) return `${formatadas[0]} e ${formatadas[1]}`;
  const inicio = formatadas.slice(0, -1).join(", ");
  const fim = formatadas[formatadas.length - 1];
  return `${inicio} e ${fim}`;
}
__name(compactarSequenciaDias, "compactarSequenciaDias");
function compactarHorarios(horario) {
  const horarios = [
    horario.Ent1,
    horario.Sai1,
    horario.Ent2,
    horario.Sai2,
    horario.Ent3,
    horario.Sai3
  ].filter(Boolean);
  return Array.from({
    length: 3
  }).reduce((acc, _, i) => {
    const nextEntrada = horarios.shift(), nextSaida = horarios.shift();
    if (nextEntrada && nextSaida) {
      acc[`Ent${i + 1}`] = nextEntrada;
      acc[`Sai${i + 1}`] = nextSaida;
    }
    return acc;
  }, {});
}
__name(compactarHorarios, "compactarHorarios");
function compactarJornada(horarios) {
  const entradasSaidas = horarios.map((horario, index) => ({
    dia: diasSemana[index],
    entradaSaida: compactarHorarios({
      Ent1: horario.Ent1,
      Sai1: horario.Sai1,
      Ent2: horario.Ent2,
      Sai2: horario.Sai2,
      Ent3: horario.Ent3,
      Sai3: horario.Sai3
    })
  }));
  const comparavel = entradasSaidas.map(({ dia, entradaSaida }) => ({
    dia,
    entradasSaidas: JSON.stringify(entradaSaida)
  }));
  const grouped = groupBy(comparavel, "entradasSaidas");
  const [sequencias, duplas, solitarios] = [
    [],
    [],
    []
  ];
  for (const value of Object.values(grouped)) {
    if (value.length > 2) sequencias.push(value);
    else if (value.length === 2) duplas.push(value);
    else solitarios.push(value);
  }
  const res = [];
  for (const seq of sequencias) {
    const diasAbreviados = seq.map((s) => s.dia.slice(0, 3));
    const diasCompactados = compactarSequenciaDias(diasAbreviados);
    if (JSON.parse(seq[0].entradasSaidas).Ent1) res.push({
      dia: diasCompactados,
      entradasSaidas: JSON.parse(seq[0].entradasSaidas),
      total: horarios.find((h) => h.label === seq[0].dia)?.Tot
    });
  }
  for (const dupla of duplas) {
    const diasAbreviados = dupla.map((d) => d.dia.slice(0, 3));
    const diasCompactados = compactarSequenciaDias(diasAbreviados);
    if (JSON.parse(dupla[0].entradasSaidas).Ent1) res.push({
      dia: diasCompactados,
      entradasSaidas: JSON.parse(dupla[0].entradasSaidas),
      total: horarios.find((h) => h.label === dupla[0].dia)?.Tot
    });
  }
  for (const solitario of solitarios) {
    if (JSON.parse(solitario[0].entradasSaidas).Ent1) res.push({
      dia: solitario[0].dia.slice(0, 3),
      entradasSaidas: JSON.parse(solitario[0].entradasSaidas),
      total: horarios.find((h) => h.label === solitario[0].dia)?.Tot
    });
  }
  return res.filter((r) => r.total);
}
__name(compactarJornada, "compactarJornada");

// src/domain/utils/csv/csvMapper.ts
import { Err, Ok } from "oxide.ts";
var types = {
  CsvString: "string",
  CsvNumber: "number",
  CsvBoolean: "boolean",
  CsvObject: "object"
};
var _DifferentHeadersError = class _DifferentHeadersError extends Error {
  constructor(headers, expected) {
    super("O cabe\xE7alho do CSV n\xE3o \xE9 igual ao esperado");
    __publicField(this, "headers");
    __publicField(this, "expected");
    this.headers = headers, this.expected = expected;
  }
  toJSON() {
    return {
      message: this.message,
      headers: this.headers,
      expected: this.expected
    };
  }
};
__name(_DifferentHeadersError, "DifferentHeadersError");
var DifferentHeadersError = _DifferentHeadersError;
var _WrongTypeError = class _WrongTypeError extends Error {
  constructor(expected, received, line, header) {
    super("O tipo do valor n\xE3o \xE9 o esperado");
    __publicField(this, "expected");
    __publicField(this, "received");
    __publicField(this, "line");
    __publicField(this, "header");
    this.expected = expected, this.received = received, this.line = line, this.header = header;
  }
  toJSON() {
    return {
      message: this.message,
      expected: this.expected,
      received: this.received,
      line: this.line,
      header: this.header
    };
  }
};
__name(_WrongTypeError, "WrongTypeError");
var WrongTypeError = _WrongTypeError;
var _CsvMapper = class _CsvMapper {
  constructor(props, schema) {
    __publicField(this, "_props");
    __publicField(this, "_headers");
    __publicField(this, "_schema");
    __publicField(this, "_size");
    if (schema) {
      this._schema = schema;
      this._headers = Object.keys(schema(types));
      this._props = new Map(this._headers.map((header) => [
        header,
        props.map((item) => item[header])
      ]));
    } else {
      this._headers = Array.from(new Set(props.map((item) => Object.keys(item)).reduce((acc, item) => [
        ...acc,
        ...item
      ], [])));
    }
    this._size = props.length;
    this._props = new Map(this._headers.map((header) => [
      header,
      props.map((item) => item[header])
    ]));
  }
  toCsv() {
    const headers = this._headers.join(";");
    const rows = this._props.get(this._headers[0])?.map((_, index) => {
      return this._headers.map((header) => {
        const value = this._props.get(header)?.[index];
        if (value == null) {
          return "";
        } else if (typeof value === "object") {
          return `"${JSON.stringify(value).replace(/\n?\t/g, "").replace(/"/g, '""')}"`;
        } else {
          const str = String(value);
          if (str.includes(" ")) {
            return `"${str}"`;
          } else {
            return str;
          }
        }
      }).join(";");
    }).join("\n");
    return `${headers}
${rows}`;
  }
  toPlain(options) {
    return Array.from({
      length: this._size
    }).map((_, index) => {
      return this._headers.reduce((acc, header) => {
        const value = this._props.get(header)?.[index];
        return {
          ...acc,
          [header]: value === 0 && options?.zeroToNull ? null : typeof value === "string" && value === "" && options?.emptyStringToNull ? null : value
        };
      }, {});
    });
  }
  static from(csv, schema) {
    const schemaType = schema(types);
    const lines = csv.split(/\r?\n|\r/g);
    const headers = lines[0].split(";");
    const hasMissingHeader = Object.keys(schemaType).some((header) => !headers.includes(header));
    if (hasMissingHeader) {
      return Err(new DifferentHeadersError(headers, Object.keys(schemaType)));
    }
    const rows = lines.slice(1).filter(Boolean).map((line) => line.split(";"));
    try {
      const props = rows.map((row) => {
        return row.reduce((acc, item, index) => {
          const line = index + 1;
          const header = headers[index];
          const type = schemaType[header];
          const value = transformValue(item, type, line, header);
          if (value.isErr()) {
            throw value.unwrapErr();
          }
          return {
            ...acc,
            [header]: value.unwrap()
          };
        }, {});
      });
      return Ok(new this(props, schema));
    } catch (error) {
      return Err(error);
    }
  }
  downloadCsv(filename) {
    const csv = this.toCsv();
    const link = document.createElement("a");
    link.setAttribute("href", `data:text/csv;charset=utf-8,${csv}`);
    link.setAttribute("download", filename);
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
__name(_CsvMapper, "CsvMapper");
var CsvMapper = _CsvMapper;
function transformValue(value, type, line, header) {
  const valueSemAspas = String(value).replace(/"/g, "");
  switch (type) {
    case "string":
      return Ok(valueSemAspas);
    case "number":
      return Number.isNaN(Number(valueSemAspas)) ? Err(new WrongTypeError(type, valueSemAspas, line, header)) : Ok(Number(valueSemAspas));
    case "boolean":
      return Ok(Boolean(valueSemAspas));
    case "object":
      try {
        return Ok(JSON.parse(String(value).slice(1, -1).replace(/""/g, '"')));
      } catch {
        return Err(new WrongTypeError(type, valueSemAspas, line, header));
      }
    default:
      return Ok(String(valueSemAspas));
  }
}
__name(transformValue, "transformValue");

// src/domain/utils/defer/defer.decorator.ts
var DEFER_SYMBOL = Symbol("defer");
function Defer() {
  return /* @__PURE__ */ __name(function callMethodDecorator(_target, _propertyKey, descriptor) {
    if (!descriptor) {
      throw new Error("Only use @Defer() on methods");
    }
    const oldValue = descriptor.value;
    async function deferizedMethod(...args) {
      if (!this[DEFER_SYMBOL]) {
        this[DEFER_SYMBOL] = [];
      }
      try {
        const ret = await oldValue.apply(this, args);
        return ret;
      } finally {
        if (this[DEFER_SYMBOL]) {
          const deferCallbacks = this[DEFER_SYMBOL];
          while (true) {
            const fn = deferCallbacks?.pop();
            if (!fn) {
              break;
            }
            try {
              fn();
            } catch (e) {
              console.error(e);
            }
          }
        }
      }
    }
    __name(deferizedMethod, "deferizedMethod");
    descriptor.value = deferizedMethod;
    return descriptor;
  }, "callMethodDecorator");
}
__name(Defer, "Defer");
function defer(cb) {
  if (this[DEFER_SYMBOL]) {
    this[DEFER_SYMBOL].push(cb);
  } else {
    throw new Error("Only use defer() inside @Defer() methods");
  }
}
__name(defer, "defer");

// src/domain/utils/invariant.ts
function invariant(condition, error) {
  if (typeof condition !== "boolean" && Maybe.isSome(condition)) return;
  if (!condition) throw typeof error === "string" ? new Error(error) : error;
}
__name(invariant, "invariant");

// src/domain/utils/mapAjustesEspelho.ts
import { OrigensEnum } from "@acme/common";
function mapAjustes(row) {
  const result = {};
  const entKeys = Object.keys(row).filter((k) => k.startsWith("ent")), saiKeys = Object.keys(row).filter((k) => k.startsWith("sai")), origens = row.origens ?? {}, entMax = entKeys.length ? Math.max(...entKeys.map((k) => +k.slice(3))) : 0, saiMax = saiKeys.length ? Math.max(...saiKeys.map((k) => +k.slice(3))) : 0, max = Math.max(entMax, saiMax);
  for (let i = 1; i <= max; i++) {
    for (const prefix of [
      "ent",
      "sai"
    ]) {
      const key = `${prefix}${i}`;
      const value = row[key];
      result[key] = value && origens[value] === OrigensEnum.MANUAL_SUPERVISOR ? value + "*" : value;
    }
  }
  return result;
}
__name(mapAjustes, "mapAjustes");

// src/domain/api-scopes.ts
var SCOPES_CONHECIDOS = [
  "registros:read",
  "funcionarios:read",
  "calculo:read",
  "saldo-horas:read"
];
function isScope(valor) {
  return SCOPES_CONHECIDOS.includes(valor);
}
__name(isScope, "isScope");

// src/domain/inconsistencias.ts
var FILTROS = [
  "abonos",
  "afastamentos",
  "faltasIntegrais",
  "faltasParciais",
  "horasExtrasExcedentes",
  "intervaloJornadasInferior",
  "intervaloTurnosInferior",
  "intervaloTurnosSuperior",
  "batidaImpar"
];
function temFiltroInconsistencia(filtros) {
  return FILTROS.some((filtro) => filtros[filtro] === true);
}
__name(temFiltroInconsistencia, "temFiltroInconsistencia");
function detectarInconsistencias(linhas, filtros) {
  if (!temFiltroInconsistencia(filtros)) return [];
  const afastamentosIncluidos = /* @__PURE__ */ new Set();
  return linhas.flatMap((linha) => {
    const inconsistencias = [];
    if (filtros.batidaImpar && linha.registros.length % 2 !== 0) {
      inconsistencias.push({
        espelhoPontoId: linha.id,
        tipo: "batidaImpar",
        valor: linha.registros.at(-1) ?? ""
      });
    }
    if (filtros.horasExtrasExcedentes) {
      const excesso = horasParaMinutos(linha.horasExtra) - 120;
      if (excesso > 0) {
        inconsistencias.push({
          espelhoPontoId: linha.id,
          tipo: "horasExtrasExcedentes",
          valor: minutosParaHoras(excesso)
        });
      }
    }
    if (filtros.abonos && linha.abono) {
      inconsistencias.push({
        espelhoPontoId: linha.id,
        tipo: "abonos",
        valor: linha.abono
      });
    }
    if (filtros.afastamentos && linha.afastamento && !afastamentosIncluidos.has(linha.afastamento.id)) {
      afastamentosIncluidos.add(linha.afastamento.id);
      inconsistencias.push({
        espelhoPontoId: linha.id,
        tipo: "afastamentos",
        valor: linha.afastamento
      });
    }
    const faltaEmMinutos = horasParaMinutos(linha.faltas);
    const faltaIntegral = faltaEmMinutos > 0 && horasParaMinutos(linha.horasTrabalhadas) === 0;
    if (filtros.faltasIntegrais && faltaIntegral) {
      inconsistencias.push({
        espelhoPontoId: linha.id,
        tipo: "faltasIntegrais",
        valor: true
      });
    }
    if (filtros.faltasParciais && faltaEmMinutos > 0 && !faltaIntegral) {
      inconsistencias.push({
        espelhoPontoId: linha.id,
        tipo: "faltasParciais",
        valor: linha.faltas
      });
    }
    if (filtros.intervaloJornadasInferior) {
      const intervalo = horasParaMinutos(linha.horasInterjornada) - horasParaMinutos(linha.horasSuprimidas);
      if (intervalo > 0) {
        inconsistencias.push({
          espelhoPontoId: linha.id,
          tipo: "intervaloJornadasInferior",
          valor: minutosParaHoras(intervalo)
        });
      }
    }
    if (filtros.intervaloTurnosInferior) {
      const menorIntervalo = obterMenorIntervalo(linha.entradas, linha.saidas);
      if (menorIntervalo !== void 0 && menorIntervalo < 60) {
        inconsistencias.push({
          espelhoPontoId: linha.id,
          tipo: "intervaloTurnosInferior",
          valor: minutosParaHorasSemZeroHora(menorIntervalo)
        });
      }
    }
    if (filtros.intervaloTurnosSuperior) {
      const maiorIntervalo = obterMaiorIntervalo(linha.entradas, linha.saidas);
      if (maiorIntervalo > 120) {
        inconsistencias.push({
          espelhoPontoId: linha.id,
          tipo: "intervaloTurnosSuperior",
          valor: minutosParaHoras(maiorIntervalo)
        });
      }
    }
    return inconsistencias;
  });
}
__name(detectarInconsistencias, "detectarInconsistencias");
function horasParaMinutos(valor) {
  const [horas, minutos] = valor.split(":").map(Number);
  return horas * 60 + minutos;
}
__name(horasParaMinutos, "horasParaMinutos");
function minutosParaHoras(valor) {
  const horas = Math.floor(valor / 60);
  const minutos = valor % 60;
  return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}`;
}
__name(minutosParaHoras, "minutosParaHoras");
function minutosParaHorasSemZeroHora(valor) {
  const horas = Math.floor(valor / 60);
  const minutos = valor % 60;
  return `${horas}:${String(minutos).padStart(2, "0")}`;
}
__name(minutosParaHorasSemZeroHora, "minutosParaHorasSemZeroHora");
function obterMenorIntervalo(entradas, saidas) {
  const intervalos = entradas.flatMap((entrada) => saidas.flatMap((saida) => {
    const inicio = horasParaMinutos(saida);
    const fim = horasParaMinutos(entrada);
    return fim > inicio ? [
      fim - inicio
    ] : [];
  }));
  return intervalos.length > 0 ? Math.min(...intervalos) : void 0;
}
__name(obterMenorIntervalo, "obterMenorIntervalo");
function obterMaiorIntervalo(entradas, saidas) {
  return Math.max(0, ...saidas.slice(0, -1).flatMap((saida, indice) => {
    const proximaEntrada = entradas[indice + 1];
    if (!proximaEntrada) return [];
    return [
      Math.abs(horasParaMinutos(proximaEntrada) - horasParaMinutos(saida))
    ];
  }));
}
__name(obterMaiorIntervalo, "obterMaiorIntervalo");

// src/validators/index.ts
var validators_exports = {};
__export(validators_exports, {
  AberturaCompetenciaSchema: () => AberturaCompetenciaSchema,
  AbonoSchema: () => AbonoSchema,
  AfastamentoSchema: () => AfastamentoSchema,
  AlteracaoSchema: () => AlteracaoSchema,
  ApiClientSchema: () => ApiClientSchema,
  AvaliacaoSchema: () => AvaliacaoSchema,
  CalculoPublicViewSchema: () => CalculoPublicViewSchema,
  CalculoSchema: () => CalculoSchema,
  CartaoSchema: () => CartaoSchema,
  CentroCustoSchema: () => CentroCustoSchema,
  CertificadoSchema: () => CertificadoSchema,
  CidadeSchema: () => CidadeSchema,
  ClienteSchema: () => ClienteSchema,
  CompensacaoDiaSchema: () => CompensacaoDiaSchema,
  CompensacaoManualDestinoSchema: () => CompensacaoManualDestinoSchema,
  CompensacaoManualSchema: () => CompensacaoManualSchema,
  CompensacoesSchema: () => CompensacoesSchema,
  DescontoDsrSchema: () => DescontoDsrSchema,
  DsrSchema: () => DsrSchema,
  EmpresaSchema: () => EmpresaSchema,
  EnderecoSchema: () => EnderecoSchema,
  EscalaTrabalhoSchema: () => EscalaTrabalhoSchema,
  EscalasTrabalhoFuncionarioSchema: () => EscalasTrabalhoFuncionarioSchema,
  EspelhoPontoSchema: () => EspelhoPontoSchema,
  ExcecaoRubricaSchema: () => ExcecaoRubricaSchema,
  ExcecoesPermissaoOcorrenciaSchema: () => ExcecoesPermissaoOcorrenciaSchema,
  FaltaCadastradaSchema: () => FaltaCadastradaSchema,
  FechamentoCompetenciaSchema: () => FechamentoCompetenciaSchema,
  FeriadosClienteSchema: () => FeriadosClienteSchema,
  FeriadosNacionaisEstaduaisSchema: () => FeriadosNacionaisEstaduaisSchema,
  FiltroSchema: () => FiltroSchema,
  FolgaSchema: () => FolgaSchema,
  FuncionarioCentroCustoSchema: () => FuncionarioCentroCustoSchema,
  FuncionarioLocaisSchema: () => FuncionarioLocaisSchema,
  FuncionarioLocalPublicViewSchema: () => FuncionarioLocalPublicViewSchema,
  FuncionarioPublicViewSchema: () => FuncionarioPublicViewSchema,
  FuncionarioRepsSchema: () => FuncionarioRepsSchema,
  FuncionarioSchema: () => FuncionarioSchema,
  FuncoesAvaliacaoSchema: () => FuncoesAvaliacaoSchema,
  HistoricoCalculoEmpresaSchema: () => HistoricoCalculoEmpresaSchema,
  HistoricoCalculoLogsSchema: () => HistoricoCalculoLogsSchema,
  HistoricoCalculoSchema: () => HistoricoCalculoSchema,
  HistoricoExportacaoFolhaPagamentoSchema: () => HistoricoExportacaoFolhaPagamentoSchema,
  HistoricoImportacaoSchema: () => HistoricoImportacaoSchema,
  InconsistenciaPublicViewSchema: () => InconsistenciaPublicViewSchema,
  InterjornadaSchema: () => InterjornadaSchema,
  LocalSchema: () => LocalSchema,
  LogCalculosSchema: () => LogCalculosSchema,
  MarcaSchema: () => MarcaSchema,
  ModuloClienteSchema: () => ModuloClienteSchema,
  ModuloPermissaoSchema: () => ModuloPermissaoSchema,
  MotivoExclusaoSchema: () => MotivoExclusaoSchema,
  OcorrenciaSchema: () => OcorrenciaSchema,
  PagamentoHorasSchema: () => PagamentoHorasSchema,
  ParametrosAvaliacaoSchema: () => ParametrosAvaliacaoSchema,
  PerfilPermissaoSchema: () => PerfilPermissaoSchema,
  PlanoDiferenciadoSchema: () => PlanoDiferenciadoSchema,
  PlanoSchema: () => PlanoSchema,
  PorcentagensRegraCalculoSchema: () => PorcentagensRegraCalculoSchema,
  ReajusteAnualSchema: () => ReajusteAnualSchema,
  RegistroPublicViewSchema: () => RegistroPublicViewSchema,
  RegistroSchema: () => RegistroSchema,
  RegrasCalculoSchema: () => RegrasCalculoSchema,
  RelatorioAjusteSchema: () => RelatorioAjusteSchema,
  RepSchema: () => RepSchema,
  RubricaSchema: () => RubricaSchema,
  SaldoHorasDiarioSchema: () => SaldoHorasDiarioSchema,
  SaldoHorasPublicViewSchema: () => SaldoHorasPublicViewSchema,
  SaldoHorasSchema: () => SaldoHorasSchema,
  SegmentoSchema: () => SegmentoSchema,
  SobreavisoSchema: () => SobreavisoSchema,
  SupervisorCentroCustosSchema: () => SupervisorCentroCustosSchema,
  SupervisorEmpresasSchema: () => SupervisorEmpresasSchema,
  SupervisorLocaisSchema: () => SupervisorLocaisSchema,
  SupervisorSchema: () => SupervisorSchema,
  TabelaHorarioFuncionarioSchema: () => TabelaHorarioFuncionarioSchema,
  TabelaHorarioSchema: () => TabelaHorarioSchema,
  TreinamentoSchema: () => TreinamentoSchema,
  TrocaDiaTrabalhoSchema: () => TrocaDiaTrabalhoSchema,
  TrocaInicioPontoSchema: () => TrocaInicioPontoSchema,
  TrocaTabelaAutomaticaSchema: () => TrocaTabelaAutomaticaSchema,
  UsuarioSchema: () => UsuarioSchema,
  ValeAlimentacaoSchema: () => ValeAlimentacaoSchema
});

// ../../node_modules/.pnpm/zod@3.24.2/node_modules/zod/lib/index.mjs
var util;
(function(util2) {
  util2.assertEqual = (val) => val;
  function assertIs(_arg) {
  }
  __name(assertIs, "assertIs");
  util2.assertIs = assertIs;
  function assertNever(_x) {
    throw new Error();
  }
  __name(assertNever, "assertNever");
  util2.assertNever = assertNever;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item of items) {
      obj[item] = item;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
    const filtered = {};
    for (const k of validKeys) {
      filtered[k] = obj[k];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function(e) {
      return obj[e];
    });
  };
  util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
    const keys = [];
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }
    return keys;
  };
  util2.find = (arr, checker) => {
    for (const item of arr) {
      if (checker(item))
        return item;
    }
    return void 0;
  };
  util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
  function joinValues(array, separator = " | ") {
    return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
  }
  __name(joinValues, "joinValues");
  util2.joinValues = joinValues;
  util2.jsonStringifyReplacer = (_, value) => {
    if (typeof value === "bigint") {
      return value.toString();
    }
    return value;
  };
})(util || (util = {}));
var objectUtil;
(function(objectUtil2) {
  objectUtil2.mergeShapes = (first, second) => {
    return {
      ...first,
      ...second
      // second overwrites first
    };
  };
})(objectUtil || (objectUtil = {}));
var ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]);
var getParsedType = /* @__PURE__ */ __name((data) => {
  const t = typeof data;
  switch (t) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }
      if (data === null) {
        return ZodParsedType.null;
      }
      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
}, "getParsedType");
var ZodIssueCode = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
var quotelessJson = /* @__PURE__ */ __name((obj) => {
  const json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
}, "quotelessJson");
var _ZodError = class _ZodError extends Error {
  get errors() {
    return this.issues;
  }
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub) => {
      this.issues = [...this.issues, sub];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = "ZodError";
    this.issues = issues;
  }
  format(_mapper) {
    const mapper = _mapper || function(issue) {
      return issue.message;
    };
    const fieldErrors = { _errors: [] };
    const processError = /* @__PURE__ */ __name((error) => {
      for (const issue of error.issues) {
        if (issue.code === "invalid_union") {
          issue.unionErrors.map(processError);
        } else if (issue.code === "invalid_return_type") {
          processError(issue.returnTypeError);
        } else if (issue.code === "invalid_arguments") {
          processError(issue.argumentsError);
        } else if (issue.path.length === 0) {
          fieldErrors._errors.push(mapper(issue));
        } else {
          let curr = fieldErrors;
          let i = 0;
          while (i < issue.path.length) {
            const el = issue.path[i];
            const terminal = i === issue.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue));
            }
            curr = curr[el];
            i++;
          }
        }
      }
    }, "processError");
    processError(this);
    return fieldErrors;
  }
  static assert(value) {
    if (!(value instanceof _ZodError)) {
      throw new Error(`Not a ZodError: ${value}`);
    }
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue) => issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of this.issues) {
      if (sub.path.length > 0) {
        fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
        fieldErrors[sub.path[0]].push(mapper(sub));
      } else {
        formErrors.push(mapper(sub));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
};
__name(_ZodError, "ZodError");
var ZodError = _ZodError;
ZodError.create = (issues) => {
  const error = new ZodError(issues);
  return error;
};
var errorMap = /* @__PURE__ */ __name((issue, _ctx) => {
  let message;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = "Required";
      } else {
        message = `Expected ${issue.expected}, received ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message = `Invalid function arguments`;
      break;
    case ZodIssueCode.invalid_return_type:
      message = `Invalid function return type`;
      break;
    case ZodIssueCode.invalid_date:
      message = `Invalid date`;
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === "object") {
        if ("includes" in issue.validation) {
          message = `Invalid input: must include "${issue.validation.includes}"`;
          if (typeof issue.validation.position === "number") {
            message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
          }
        } else if ("startsWith" in issue.validation) {
          message = `Invalid input: must start with "${issue.validation.startsWith}"`;
        } else if ("endsWith" in issue.validation) {
          message = `Invalid input: must end with "${issue.validation.endsWith}"`;
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message = `Invalid ${issue.validation}`;
      } else {
        message = "Invalid";
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "bigint")
        message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.custom:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_intersection_types:
      message = `Intersection results could not be merged`;
      break;
    case ZodIssueCode.not_multiple_of:
      message = `Number must be a multiple of ${issue.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      message = "Number must be finite";
      break;
    default:
      message = _ctx.defaultError;
      util.assertNever(issue);
  }
  return { message };
}, "errorMap");
var overrideErrorMap = errorMap;
function setErrorMap(map) {
  overrideErrorMap = map;
}
__name(setErrorMap, "setErrorMap");
function getErrorMap() {
  return overrideErrorMap;
}
__name(getErrorMap, "getErrorMap");
var makeIssue = /* @__PURE__ */ __name((params) => {
  const { data, path, errorMaps, issueData } = params;
  const fullPath = [...path, ...issueData.path || []];
  const fullIssue = {
    ...issueData,
    path: fullPath
  };
  if (issueData.message !== void 0) {
    return {
      ...issueData,
      path: fullPath,
      message: issueData.message
    };
  }
  let errorMessage = "";
  const maps = errorMaps.filter((m) => !!m).slice().reverse();
  for (const map of maps) {
    errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
  }
  return {
    ...issueData,
    path: fullPath,
    message: errorMessage
  };
}, "makeIssue");
var EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
  const overrideMap = getErrorMap();
  const issue = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      // contextual error map is first priority
      ctx.schemaErrorMap,
      // then schema-bound map if available
      overrideMap,
      // then global override map
      overrideMap === errorMap ? void 0 : errorMap
      // then global default map
    ].filter((x) => !!x)
  });
  ctx.common.issues.push(issue);
}
__name(addIssueToContext, "addIssueToContext");
var _ParseStatus = class _ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    if (this.value === "valid")
      this.value = "dirty";
  }
  abort() {
    if (this.value !== "aborted")
      this.value = "aborted";
  }
  static mergeArray(status, results) {
    const arrayValue = [];
    for (const s of results) {
      if (s.status === "aborted")
        return INVALID;
      if (s.status === "dirty")
        status.dirty();
      arrayValue.push(s.value);
    }
    return { status: status.value, value: arrayValue };
  }
  static async mergeObjectAsync(status, pairs) {
    const syncPairs = [];
    for (const pair of pairs) {
      const key = await pair.key;
      const value = await pair.value;
      syncPairs.push({
        key,
        value
      });
    }
    return _ParseStatus.mergeObjectSync(status, syncPairs);
  }
  static mergeObjectSync(status, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key, value } = pair;
      if (key.status === "aborted")
        return INVALID;
      if (value.status === "aborted")
        return INVALID;
      if (key.status === "dirty")
        status.dirty();
      if (value.status === "dirty")
        status.dirty();
      if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
        finalObject[key.value] = value.value;
      }
    }
    return { status: status.value, value: finalObject };
  }
};
__name(_ParseStatus, "ParseStatus");
var ParseStatus = _ParseStatus;
var INVALID = Object.freeze({
  status: "aborted"
});
var DIRTY = /* @__PURE__ */ __name((value) => ({ status: "dirty", value }), "DIRTY");
var OK = /* @__PURE__ */ __name((value) => ({ status: "valid", value }), "OK");
var isAborted = /* @__PURE__ */ __name((x) => x.status === "aborted", "isAborted");
var isDirty = /* @__PURE__ */ __name((x) => x.status === "dirty", "isDirty");
var isValid = /* @__PURE__ */ __name((x) => x.status === "valid", "isValid");
var isAsync = /* @__PURE__ */ __name((x) => typeof Promise !== "undefined" && x instanceof Promise, "isAsync");
function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
__name(__classPrivateFieldGet, "__classPrivateFieldGet");
function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
__name(__classPrivateFieldSet, "__classPrivateFieldSet");
var errorUtil;
(function(errorUtil2) {
  errorUtil2.errToObj = (message) => typeof message === "string" ? { message } : message || {};
  errorUtil2.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));
var _ZodEnum_cache;
var _ZodNativeEnum_cache;
var _ParseInputLazyPath = class _ParseInputLazyPath {
  constructor(parent, value, path, key) {
    this._cachedPath = [];
    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (this._key instanceof Array) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
};
__name(_ParseInputLazyPath, "ParseInputLazyPath");
var ParseInputLazyPath = _ParseInputLazyPath;
var handleResult = /* @__PURE__ */ __name((ctx, result) => {
  if (isValid(result)) {
    return { success: true, data: result.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    return {
      success: false,
      get error() {
        if (this._error)
          return this._error;
        const error = new ZodError(ctx.common.issues);
        this._error = error;
        return this._error;
      }
    };
  }
}, "handleResult");
function processCreateParams(params) {
  if (!params)
    return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  }
  if (errorMap2)
    return { errorMap: errorMap2, description };
  const customMap = /* @__PURE__ */ __name((iss, ctx) => {
    var _a3, _b;
    const { message } = params;
    if (iss.code === "invalid_enum_value") {
      return { message: message !== null && message !== void 0 ? message : ctx.defaultError };
    }
    if (typeof ctx.data === "undefined") {
      return { message: (_a3 = message !== null && message !== void 0 ? message : required_error) !== null && _a3 !== void 0 ? _a3 : ctx.defaultError };
    }
    if (iss.code !== "invalid_type")
      return { message: ctx.defaultError };
    return { message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError };
  }, "customMap");
  return { errorMap: customMap, description };
}
__name(processCreateParams, "processCreateParams");
var _ZodType = class _ZodType {
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return ctx || {
      common: input.parent.common,
      data: input.data,
      parsedType: getParsedType(input.data),
      schemaErrorMap: this._def.errorMap,
      path: input.path,
      parent: input.parent
    };
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      }
    };
  }
  _parseSync(input) {
    const result = this._parse(input);
    if (isAsync(result)) {
      throw new Error("Synchronous parse encountered promise.");
    }
    return result;
  }
  _parseAsync(input) {
    const result = this._parse(input);
    return Promise.resolve(result);
  }
  parse(data, params) {
    const result = this.safeParse(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  safeParse(data, params) {
    var _a3;
    const ctx = {
      common: {
        issues: [],
        async: (_a3 = params === null || params === void 0 ? void 0 : params.async) !== null && _a3 !== void 0 ? _a3 : false,
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const result = this._parseSync({ data, path: ctx.path, parent: ctx });
    return handleResult(ctx, result);
  }
  "~validate"(data) {
    var _a3, _b;
    const ctx = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    if (!this["~standard"].async) {
      try {
        const result = this._parseSync({ data, path: [], parent: ctx });
        return isValid(result) ? {
          value: result.value
        } : {
          issues: ctx.common.issues
        };
      } catch (err) {
        if ((_b = (_a3 = err === null || err === void 0 ? void 0 : err.message) === null || _a3 === void 0 ? void 0 : _a3.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("encountered")) {
          this["~standard"].async = true;
        }
        ctx.common = {
          issues: [],
          async: true
        };
      }
    }
    return this._parseAsync({ data, path: [], parent: ctx }).then((result) => isValid(result) ? {
      value: result.value
    } : {
      issues: ctx.common.issues
    });
  }
  async parseAsync(data, params) {
    const result = await this.safeParseAsync(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  async safeParseAsync(data, params) {
    const ctx = {
      common: {
        issues: [],
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
        async: true
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
    const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
    return handleResult(ctx, result);
  }
  refine(check, message) {
    const getIssueProperties = /* @__PURE__ */ __name((val) => {
      if (typeof message === "string" || typeof message === "undefined") {
        return { message };
      } else if (typeof message === "function") {
        return message(val);
      } else {
        return message;
      }
    }, "getIssueProperties");
    return this._refinement((val, ctx) => {
      const result = check(val);
      const setError = /* @__PURE__ */ __name(() => ctx.addIssue({
        code: ZodIssueCode.custom,
        ...getIssueProperties(val)
      }), "setError");
      if (typeof Promise !== "undefined" && result instanceof Promise) {
        return result.then((data) => {
          if (!data) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check, refinementData) {
    return this._refinement((val, ctx) => {
      if (!check(val)) {
        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement }
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  constructor(def) {
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
    this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: /* @__PURE__ */ __name((data) => this["~validate"](data), "validate")
    };
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(option) {
    return ZodUnion.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection.create(this, incoming, this._def);
  }
  transform(transform) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform }
    });
  }
  default(def) {
    const defaultValueFunc = typeof def === "function" ? def : () => def;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(def) {
    const catchValueFunc = typeof def === "function" ? def : () => def;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(description) {
    const This = this.constructor;
    return new This({
      ...this._def,
      description
    });
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
__name(_ZodType, "ZodType");
var ZodType = _ZodType;
var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[0-9a-z]+$/;
var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
var nanoidRegex = /^[a-z0-9_-]{21}$/i;
var jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
var durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
var _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
var emojiRegex;
var ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
var ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
var ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
var ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
var base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
var base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
var dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
var dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
  let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
  if (args.precision) {
    regex = `${regex}\\.\\d{${args.precision}}`;
  } else if (args.precision == null) {
    regex = `${regex}(\\.\\d+)?`;
  }
  return regex;
}
__name(timeRegexSource, "timeRegexSource");
function timeRegex(args) {
  return new RegExp(`^${timeRegexSource(args)}$`);
}
__name(timeRegex, "timeRegex");
function datetimeRegex(args) {
  let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
  const opts = [];
  opts.push(args.local ? `Z?` : `Z`);
  if (args.offset)
    opts.push(`([+-]\\d{2}:?\\d{2})`);
  regex = `${regex}(${opts.join("|")})`;
  return new RegExp(`^${regex}$`);
}
__name(datetimeRegex, "datetimeRegex");
function isValidIP(ip, version) {
  if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}
__name(isValidIP, "isValidIP");
function isValidJWT(jwt, alg) {
  if (!jwtRegex.test(jwt))
    return false;
  try {
    const [header] = jwt.split(".");
    const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
    const decoded = JSON.parse(atob(base64));
    if (typeof decoded !== "object" || decoded === null)
      return false;
    if (!decoded.typ || !decoded.alg)
      return false;
    if (alg && decoded.alg !== alg)
      return false;
    return true;
  } catch (_a3) {
    return false;
  }
}
__name(isValidJWT, "isValidJWT");
function isValidCidr(ip, version) {
  if ((version === "v4" || !version) && ipv4CidrRegex.test(ip)) {
    return true;
  }
  if ((version === "v6" || !version) && ipv6CidrRegex.test(ip)) {
    return true;
  }
  return false;
}
__name(isValidCidr, "isValidCidr");
var _ZodString = class _ZodString extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.string,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.length < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.length > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "length") {
        const tooBig = input.data.length > check.value;
        const tooSmall = input.data.length < check.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          }
          status.dirty();
        }
      } else if (check.kind === "email") {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "email",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "emoji") {
        if (!emojiRegex) {
          emojiRegex = new RegExp(_emojiRegex, "u");
        }
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "emoji",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "uuid") {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "uuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "nanoid") {
        if (!nanoidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "nanoid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid") {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid2") {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid2",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ulid") {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ulid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "url") {
        try {
          new URL(input.data);
        } catch (_a3) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "regex") {
        check.regex.lastIndex = 0;
        const testResult = check.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "regex",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "trim") {
        input.data = input.data.trim();
      } else if (check.kind === "includes") {
        if (!input.data.includes(check.value, check.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { includes: check.value, position: check.position },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "toLowerCase") {
        input.data = input.data.toLowerCase();
      } else if (check.kind === "toUpperCase") {
        input.data = input.data.toUpperCase();
      } else if (check.kind === "startsWith") {
        if (!input.data.startsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { startsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "endsWith") {
        if (!input.data.endsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { endsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "datetime") {
        const regex = datetimeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "datetime",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "date") {
        const regex = dateRegex;
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "date",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "time") {
        const regex = timeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "time",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "duration") {
        if (!durationRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "duration",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ip") {
        if (!isValidIP(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ip",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "jwt") {
        if (!isValidJWT(input.data, check.alg)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "jwt",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cidr") {
        if (!isValidCidr(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cidr",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "base64") {
        if (!base64Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "base64",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "base64url") {
        if (!base64urlRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "base64url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _regex(regex, validation, message) {
    return this.refinement((data) => regex.test(data), {
      validation,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(message)
    });
  }
  _addCheck(check) {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  email(message) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
  }
  url(message) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
  }
  emoji(message) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
  }
  uuid(message) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
  }
  nanoid(message) {
    return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(message) });
  }
  cuid(message) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
  }
  cuid2(message) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
  }
  ulid(message) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
  }
  base64(message) {
    return this._addCheck({ kind: "base64", ...errorUtil.errToObj(message) });
  }
  base64url(message) {
    return this._addCheck({
      kind: "base64url",
      ...errorUtil.errToObj(message)
    });
  }
  jwt(options) {
    return this._addCheck({ kind: "jwt", ...errorUtil.errToObj(options) });
  }
  ip(options) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
  }
  cidr(options) {
    return this._addCheck({ kind: "cidr", ...errorUtil.errToObj(options) });
  }
  datetime(options) {
    var _a3, _b;
    if (typeof options === "string") {
      return this._addCheck({
        kind: "datetime",
        precision: null,
        offset: false,
        local: false,
        message: options
      });
    }
    return this._addCheck({
      kind: "datetime",
      precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
      offset: (_a3 = options === null || options === void 0 ? void 0 : options.offset) !== null && _a3 !== void 0 ? _a3 : false,
      local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
      ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
    });
  }
  date(message) {
    return this._addCheck({ kind: "date", message });
  }
  time(options) {
    if (typeof options === "string") {
      return this._addCheck({
        kind: "time",
        precision: null,
        message: options
      });
    }
    return this._addCheck({
      kind: "time",
      precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
      ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
    });
  }
  duration(message) {
    return this._addCheck({ kind: "duration", ...errorUtil.errToObj(message) });
  }
  regex(regex, message) {
    return this._addCheck({
      kind: "regex",
      regex,
      ...errorUtil.errToObj(message)
    });
  }
  includes(value, options) {
    return this._addCheck({
      kind: "includes",
      value,
      position: options === null || options === void 0 ? void 0 : options.position,
      ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
    });
  }
  startsWith(value, message) {
    return this._addCheck({
      kind: "startsWith",
      value,
      ...errorUtil.errToObj(message)
    });
  }
  endsWith(value, message) {
    return this._addCheck({
      kind: "endsWith",
      value,
      ...errorUtil.errToObj(message)
    });
  }
  min(minLength, message) {
    return this._addCheck({
      kind: "min",
      value: minLength,
      ...errorUtil.errToObj(message)
    });
  }
  max(maxLength, message) {
    return this._addCheck({
      kind: "max",
      value: maxLength,
      ...errorUtil.errToObj(message)
    });
  }
  length(len, message) {
    return this._addCheck({
      kind: "length",
      value: len,
      ...errorUtil.errToObj(message)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(message) {
    return this.min(1, errorUtil.errToObj(message));
  }
  trim() {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((ch) => ch.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((ch) => ch.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((ch) => ch.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((ch) => ch.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((ch) => ch.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((ch) => ch.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((ch) => ch.kind === "base64url");
  }
  get minLength() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxLength() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
__name(_ZodString, "ZodString");
var ZodString = _ZodString;
ZodString.create = (params) => {
  var _a3;
  return new ZodString({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (_a3 = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a3 !== void 0 ? _a3 : false,
    ...processCreateParams(params)
  });
};
function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / Math.pow(10, decCount);
}
__name(floatSafeRemainder, "floatSafeRemainder");
var _ZodNumber = class _ZodNumber extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "int") {
        if (!util.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: "integer",
            received: "float",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (floatSafeRemainder(input.data, check.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "finite") {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_finite,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check) {
    return new _ZodNumber({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  int(message) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(message)
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  finite(message) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(message)
    });
  }
  safe(message) {
    return this._addCheck({
      kind: "min",
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message)
    })._addCheck({
      kind: "max",
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
  get isInt() {
    return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
  }
  get isFinite() {
    let max = null, min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
        return true;
      } else if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      } else if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return Number.isFinite(min) && Number.isFinite(max);
  }
};
__name(_ZodNumber, "ZodNumber");
var ZodNumber = _ZodNumber;
ZodNumber.create = (params) => {
  return new ZodNumber({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    ...processCreateParams(params)
  });
};
var _ZodBigInt = class _ZodBigInt extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      try {
        input.data = BigInt(input.data);
      } catch (_a3) {
        return this._getInvalidInput(input);
      }
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.bigint) {
      return this._getInvalidInput(input);
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            type: "bigint",
            minimum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            type: "bigint",
            maximum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (input.data % check.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _getInvalidInput(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.bigint,
      received: ctx.parsedType
    });
    return INVALID;
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check) {
    return new _ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
__name(_ZodBigInt, "ZodBigInt");
var ZodBigInt = _ZodBigInt;
ZodBigInt.create = (params) => {
  var _a3;
  return new ZodBigInt({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (_a3 = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a3 !== void 0 ? _a3 : false,
    ...processCreateParams(params)
  });
};
var _ZodBoolean = class _ZodBoolean extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
__name(_ZodBoolean, "ZodBoolean");
var ZodBoolean = _ZodBoolean;
ZodBoolean.create = (params) => {
  return new ZodBoolean({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    ...processCreateParams(params)
  });
};
var _ZodDate = class _ZodDate extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    if (isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_date
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.getTime() < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            message: check.message,
            inclusive: true,
            exact: false,
            minimum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.getTime() > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            message: check.message,
            inclusive: true,
            exact: false,
            maximum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return {
      status: status.value,
      value: new Date(input.data.getTime())
    };
  }
  _addCheck(check) {
    return new _ZodDate({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  min(minDate, message) {
    return this._addCheck({
      kind: "min",
      value: minDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  max(maxDate, message) {
    return this._addCheck({
      kind: "max",
      value: maxDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  get minDate() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min != null ? new Date(min) : null;
  }
  get maxDate() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max != null ? new Date(max) : null;
  }
};
__name(_ZodDate, "ZodDate");
var ZodDate = _ZodDate;
ZodDate.create = (params) => {
  return new ZodDate({
    checks: [],
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    typeName: ZodFirstPartyTypeKind.ZodDate,
    ...processCreateParams(params)
  });
};
var _ZodSymbol = class _ZodSymbol extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
__name(_ZodSymbol, "ZodSymbol");
var ZodSymbol = _ZodSymbol;
ZodSymbol.create = (params) => {
  return new ZodSymbol({
    typeName: ZodFirstPartyTypeKind.ZodSymbol,
    ...processCreateParams(params)
  });
};
var _ZodUndefined = class _ZodUndefined extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
__name(_ZodUndefined, "ZodUndefined");
var ZodUndefined = _ZodUndefined;
ZodUndefined.create = (params) => {
  return new ZodUndefined({
    typeName: ZodFirstPartyTypeKind.ZodUndefined,
    ...processCreateParams(params)
  });
};
var _ZodNull = class _ZodNull extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
__name(_ZodNull, "ZodNull");
var ZodNull = _ZodNull;
ZodNull.create = (params) => {
  return new ZodNull({
    typeName: ZodFirstPartyTypeKind.ZodNull,
    ...processCreateParams(params)
  });
};
var _ZodAny = class _ZodAny extends ZodType {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
__name(_ZodAny, "ZodAny");
var ZodAny = _ZodAny;
ZodAny.create = (params) => {
  return new ZodAny({
    typeName: ZodFirstPartyTypeKind.ZodAny,
    ...processCreateParams(params)
  });
};
var _ZodUnknown = class _ZodUnknown extends ZodType {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
__name(_ZodUnknown, "ZodUnknown");
var ZodUnknown = _ZodUnknown;
ZodUnknown.create = (params) => {
  return new ZodUnknown({
    typeName: ZodFirstPartyTypeKind.ZodUnknown,
    ...processCreateParams(params)
  });
};
var _ZodNever = class _ZodNever extends ZodType {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType
    });
    return INVALID;
  }
};
__name(_ZodNever, "ZodNever");
var ZodNever = _ZodNever;
ZodNever.create = (params) => {
  return new ZodNever({
    typeName: ZodFirstPartyTypeKind.ZodNever,
    ...processCreateParams(params)
  });
};
var _ZodVoid = class _ZodVoid extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
__name(_ZodVoid, "ZodVoid");
var ZodVoid = _ZodVoid;
ZodVoid.create = (params) => {
  return new ZodVoid({
    typeName: ZodFirstPartyTypeKind.ZodVoid,
    ...processCreateParams(params)
  });
};
var _ZodArray = class _ZodArray extends ZodType {
  _parse(input) {
    const { ctx, status } = this._processInputParams(input);
    const def = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (def.exactLength !== null) {
      const tooBig = ctx.data.length > def.exactLength.value;
      const tooSmall = ctx.data.length < def.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
          minimum: tooSmall ? def.exactLength.value : void 0,
          maximum: tooBig ? def.exactLength.value : void 0,
          type: "array",
          inclusive: true,
          exact: true,
          message: def.exactLength.message
        });
        status.dirty();
      }
    }
    if (def.minLength !== null) {
      if (ctx.data.length < def.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.minLength.message
        });
        status.dirty();
      }
    }
    if (def.maxLength !== null) {
      if (ctx.data.length > def.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.maxLength.message
        });
        status.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all([...ctx.data].map((item, i) => {
        return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      })).then((result2) => {
        return ParseStatus.mergeArray(status, result2);
      });
    }
    const result = [...ctx.data].map((item, i) => {
      return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
    });
    return ParseStatus.mergeArray(status, result);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message) {
    return new _ZodArray({
      ...this._def,
      minLength: { value: minLength, message: errorUtil.toString(message) }
    });
  }
  max(maxLength, message) {
    return new _ZodArray({
      ...this._def,
      maxLength: { value: maxLength, message: errorUtil.toString(message) }
    });
  }
  length(len, message) {
    return new _ZodArray({
      ...this._def,
      exactLength: { value: len, message: errorUtil.toString(message) }
    });
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
__name(_ZodArray, "ZodArray");
var ZodArray = _ZodArray;
ZodArray.create = (schema, params) => {
  return new ZodArray({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray,
    ...processCreateParams(params)
  });
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    const newShape = {};
    for (const key in schema.shape) {
      const fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject({
      ...schema._def,
      shape: /* @__PURE__ */ __name(() => newShape, "shape")
    });
  } else if (schema instanceof ZodArray) {
    return new ZodArray({
      ...schema._def,
      type: deepPartialify(schema.element)
    });
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
  } else {
    return schema;
  }
}
__name(deepPartialify, "deepPartialify");
var _ZodObject = class _ZodObject extends ZodType {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const shape = this._def.shape();
    const keys = util.objectKeys(shape);
    return this._cached = { shape, keys };
  }
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const { status, ctx } = this._processInputParams(input);
    const { shape, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
      for (const key in ctx.data) {
        if (!shapeKeys.includes(key)) {
          extraKeys.push(key);
        }
      }
    }
    const pairs = [];
    for (const key of shapeKeys) {
      const keyValidator = shape[key];
      const value = ctx.data[key];
      pairs.push({
        key: { status: "valid", value: key },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === "passthrough") {
        for (const key of extraKeys) {
          pairs.push({
            key: { status: "valid", value: key },
            value: { status: "valid", value: ctx.data[key] }
          });
        }
      } else if (unknownKeys === "strict") {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.unrecognized_keys,
            keys: extraKeys
          });
          status.dirty();
        }
      } else if (unknownKeys === "strip") ;
      else {
        throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      const catchall = this._def.catchall;
      for (const key of extraKeys) {
        const value = ctx.data[key];
        pairs.push({
          key: { status: "valid", value: key },
          value: catchall._parse(
            new ParseInputLazyPath(ctx, value, ctx.path, key)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: key in ctx.data
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve().then(async () => {
        const syncPairs = [];
        for (const pair of pairs) {
          const key = await pair.key;
          const value = await pair.value;
          syncPairs.push({
            key,
            value,
            alwaysSet: pair.alwaysSet
          });
        }
        return syncPairs;
      }).then((syncPairs) => {
        return ParseStatus.mergeObjectSync(status, syncPairs);
      });
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message) {
    errorUtil.errToObj;
    return new _ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...message !== void 0 ? {
        errorMap: /* @__PURE__ */ __name((issue, ctx) => {
          var _a3, _b, _c, _d;
          const defaultError = (_c = (_b = (_a3 = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a3, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
          if (issue.code === "unrecognized_keys")
            return {
              message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
            };
          return {
            message: defaultError
          };
        }, "errorMap")
      } : {}
    });
  }
  strip() {
    return new _ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new _ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(augmentation) {
    return new _ZodObject({
      ...this._def,
      shape: /* @__PURE__ */ __name(() => ({
        ...this._def.shape(),
        ...augmentation
      }), "shape")
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(merging) {
    const merged = new _ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: /* @__PURE__ */ __name(() => ({
        ...this._def.shape(),
        ...merging._def.shape()
      }), "shape"),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
    return merged;
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(key, schema) {
    return this.augment({ [key]: schema });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(index) {
    return new _ZodObject({
      ...this._def,
      catchall: index
    });
  }
  pick(mask) {
    const shape = {};
    util.objectKeys(mask).forEach((key) => {
      if (mask[key] && this.shape[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new _ZodObject({
      ...this._def,
      shape: /* @__PURE__ */ __name(() => shape, "shape")
    });
  }
  omit(mask) {
    const shape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (!mask[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new _ZodObject({
      ...this._def,
      shape: /* @__PURE__ */ __name(() => shape, "shape")
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      const fieldSchema = this.shape[key];
      if (mask && !mask[key]) {
        newShape[key] = fieldSchema;
      } else {
        newShape[key] = fieldSchema.optional();
      }
    });
    return new _ZodObject({
      ...this._def,
      shape: /* @__PURE__ */ __name(() => newShape, "shape")
    });
  }
  required(mask) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (mask && !mask[key]) {
        newShape[key] = this.shape[key];
      } else {
        const fieldSchema = this.shape[key];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key] = newField;
      }
    });
    return new _ZodObject({
      ...this._def,
      shape: /* @__PURE__ */ __name(() => newShape, "shape")
    });
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
};
__name(_ZodObject, "ZodObject");
var ZodObject = _ZodObject;
ZodObject.create = (shape, params) => {
  return new ZodObject({
    shape: /* @__PURE__ */ __name(() => shape, "shape"),
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.strictCreate = (shape, params) => {
  return new ZodObject({
    shape: /* @__PURE__ */ __name(() => shape, "shape"),
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.lazycreate = (shape, params) => {
  return new ZodObject({
    shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
var _ZodUnion = class _ZodUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result of results) {
        if (result.result.status === "valid") {
          return result.result;
        }
      }
      for (const result of results) {
        if (result.result.status === "dirty") {
          ctx.common.issues.push(...result.ctx.common.issues);
          return result.result;
        }
      }
      const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
    __name(handleResults, "handleResults");
    if (ctx.common.async) {
      return Promise.all(options.map(async (option) => {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          }),
          ctx: childCtx
        };
      })).then(handleResults);
    } else {
      let dirty = void 0;
      const issues = [];
      for (const option of options) {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        const result = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx
        });
        if (result.status === "valid") {
          return result;
        } else if (result.status === "dirty" && !dirty) {
          dirty = { result, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
};
__name(_ZodUnion, "ZodUnion");
var ZodUnion = _ZodUnion;
ZodUnion.create = (types2, params) => {
  return new ZodUnion({
    options: types2,
    typeName: ZodFirstPartyTypeKind.ZodUnion,
    ...processCreateParams(params)
  });
};
var getDiscriminator = /* @__PURE__ */ __name((type) => {
  if (type instanceof ZodLazy) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral) {
    return [type.value];
  } else if (type instanceof ZodEnum) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    return util.objectValues(type.enum);
  } else if (type instanceof ZodDefault) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined) {
    return [void 0];
  } else if (type instanceof ZodNull) {
    return [null];
  } else if (type instanceof ZodOptional) {
    return [void 0, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodNullable) {
    return [null, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodBranded) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodReadonly) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodCatch) {
    return getDiscriminator(type._def.innerType);
  } else {
    return [];
  }
}, "getDiscriminator");
var _ZodDiscriminatedUnion = class _ZodDiscriminatedUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator]
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(discriminator, options, params) {
    const optionsMap = /* @__PURE__ */ new Map();
    for (const type of options) {
      const discriminatorValues = getDiscriminator(type.shape[discriminator]);
      if (!discriminatorValues.length) {
        throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
      }
      for (const value of discriminatorValues) {
        if (optionsMap.has(value)) {
          throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
        }
        optionsMap.set(value, type);
      }
    }
    return new _ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap,
      ...processCreateParams(params)
    });
  }
};
__name(_ZodDiscriminatedUnion, "ZodDiscriminatedUnion");
var ZodDiscriminatedUnion = _ZodDiscriminatedUnion;
function mergeValues(a, b) {
  const aType = getParsedType(a);
  const bType = getParsedType(b);
  if (a === b) {
    return { valid: true, data: a };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util.objectKeys(b);
    const sharedKeys = util.objectKeys(a).filter((key) => bKeys.indexOf(key) !== -1);
    const newObj = { ...a, ...b };
    for (const key of sharedKeys) {
      const sharedValue = mergeValues(a[key], b[key]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a.length !== b.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index = 0; index < a.length; index++) {
      const itemA = a[index];
      const itemB = b[index];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) {
    return { valid: true, data: a };
  } else {
    return { valid: false };
  }
}
__name(mergeValues, "mergeValues");
var _ZodIntersection = class _ZodIntersection extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const handleParsed = /* @__PURE__ */ __name((parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_intersection_types
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status.dirty();
      }
      return { status: status.value, value: merged.data };
    }, "handleParsed");
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })
      ]).then(([left2, right2]) => handleParsed(left2, right2));
    } else {
      return handleParsed(this._def.left._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }), this._def.right._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }));
    }
  }
};
__name(_ZodIntersection, "ZodIntersection");
var ZodIntersection = _ZodIntersection;
ZodIntersection.create = (left2, right2, params) => {
  return new ZodIntersection({
    left: left2,
    right: right2,
    typeName: ZodFirstPartyTypeKind.ZodIntersection,
    ...processCreateParams(params)
  });
};
var _ZodTuple = class _ZodTuple extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      status.dirty();
    }
    const items = [...ctx.data].map((item, itemIndex) => {
      const schema = this._def.items[itemIndex] || this._def.rest;
      if (!schema)
        return null;
      return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
    }).filter((x) => !!x);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status, results);
      });
    } else {
      return ParseStatus.mergeArray(status, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new _ZodTuple({
      ...this._def,
      rest
    });
  }
};
__name(_ZodTuple, "ZodTuple");
var ZodTuple = _ZodTuple;
ZodTuple.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(params)
  });
};
var _ZodRecord = class _ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first, second, third) {
    if (second instanceof ZodType) {
      return new _ZodRecord({
        keyType: first,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord,
        ...processCreateParams(third)
      });
    }
    return new _ZodRecord({
      keyType: ZodString.create(),
      valueType: first,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(second)
    });
  }
};
__name(_ZodRecord, "ZodRecord");
var ZodRecord = _ZodRecord;
var _ZodMap = class _ZodMap extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key, value], index) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
      };
    });
    if (ctx.common.async) {
      const finalMap = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const pair of pairs) {
          const key = await pair.key;
          const value = await pair.value;
          if (key.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key.value, value.value);
        }
        return { status: status.value, value: finalMap };
      });
    } else {
      const finalMap = /* @__PURE__ */ new Map();
      for (const pair of pairs) {
        const key = pair.key;
        const value = pair.value;
        if (key.status === "aborted" || value.status === "aborted") {
          return INVALID;
        }
        if (key.status === "dirty" || value.status === "dirty") {
          status.dirty();
        }
        finalMap.set(key.value, value.value);
      }
      return { status: status.value, value: finalMap };
    }
  }
};
__name(_ZodMap, "ZodMap");
var ZodMap = _ZodMap;
ZodMap.create = (keyType, valueType, params) => {
  return new ZodMap({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap,
    ...processCreateParams(params)
  });
};
var _ZodSet = class _ZodSet extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const def = this._def;
    if (def.minSize !== null) {
      if (ctx.data.size < def.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.minSize.message
        });
        status.dirty();
      }
    }
    if (def.maxSize !== null) {
      if (ctx.data.size > def.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.maxSize.message
        });
        status.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = /* @__PURE__ */ new Set();
      for (const element of elements2) {
        if (element.status === "aborted")
          return INVALID;
        if (element.status === "dirty")
          status.dirty();
        parsedSet.add(element.value);
      }
      return { status: status.value, value: parsedSet };
    }
    __name(finalizeSet, "finalizeSet");
    const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message) {
    return new _ZodSet({
      ...this._def,
      minSize: { value: minSize, message: errorUtil.toString(message) }
    });
  }
  max(maxSize, message) {
    return new _ZodSet({
      ...this._def,
      maxSize: { value: maxSize, message: errorUtil.toString(message) }
    });
  }
  size(size, message) {
    return this.min(size, message).max(size, message);
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
__name(_ZodSet, "ZodSet");
var ZodSet = _ZodSet;
ZodSet.create = (valueType, params) => {
  return new ZodSet({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet,
    ...processCreateParams(params)
  });
};
var _ZodFunction = class _ZodFunction extends ZodType {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType
      });
      return INVALID;
    }
    function makeArgsIssue(args, error) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: error
        }
      });
    }
    __name(makeArgsIssue, "makeArgsIssue");
    function makeReturnsIssue(returns, error) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: error
        }
      });
    }
    __name(makeReturnsIssue, "makeReturnsIssue");
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn = ctx.data;
    if (this._def.returns instanceof ZodPromise) {
      const me = this;
      return OK(async function(...args) {
        const error = new ZodError([]);
        const parsedArgs = await me._def.args.parseAsync(args, params).catch((e) => {
          error.addIssue(makeArgsIssue(args, e));
          throw error;
        });
        const result = await Reflect.apply(fn, this, parsedArgs);
        const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e) => {
          error.addIssue(makeReturnsIssue(result, e));
          throw error;
        });
        return parsedReturns;
      });
    } else {
      const me = this;
      return OK(function(...args) {
        const parsedArgs = me._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result = Reflect.apply(fn, this, parsedArgs.data);
        const parsedReturns = me._def.returns.safeParse(result, params);
        if (!parsedReturns.success) {
          throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new _ZodFunction({
      ...this._def,
      args: ZodTuple.create(items).rest(ZodUnknown.create())
    });
  }
  returns(returnType) {
    return new _ZodFunction({
      ...this._def,
      returns: returnType
    });
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new _ZodFunction({
      args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: returns || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(params)
    });
  }
};
__name(_ZodFunction, "ZodFunction");
var ZodFunction = _ZodFunction;
var _ZodLazy = class _ZodLazy extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
};
__name(_ZodLazy, "ZodLazy");
var ZodLazy = _ZodLazy;
ZodLazy.create = (getter, params) => {
  return new ZodLazy({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy,
    ...processCreateParams(params)
  });
};
var _ZodLiteral = class _ZodLiteral extends ZodType {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
  get value() {
    return this._def.value;
  }
};
__name(_ZodLiteral, "ZodLiteral");
var ZodLiteral = _ZodLiteral;
ZodLiteral.create = (value, params) => {
  return new ZodLiteral({
    value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral,
    ...processCreateParams(params)
  });
};
function createZodEnum(values, params) {
  return new ZodEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(params)
  });
}
__name(createZodEnum, "createZodEnum");
var _ZodEnum = class _ZodEnum extends ZodType {
  constructor() {
    super(...arguments);
    _ZodEnum_cache.set(this, void 0);
  }
  _parse(input) {
    if (typeof input.data !== "string") {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f")) {
      __classPrivateFieldSet(this, _ZodEnum_cache, new Set(this._def.values), "f");
    }
    if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f").has(input.data)) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  extract(values, newDef = this._def) {
    return _ZodEnum.create(values, {
      ...this._def,
      ...newDef
    });
  }
  exclude(values, newDef = this._def) {
    return _ZodEnum.create(this.options.filter((opt) => !values.includes(opt)), {
      ...this._def,
      ...newDef
    });
  }
};
__name(_ZodEnum, "ZodEnum");
var ZodEnum = _ZodEnum;
_ZodEnum_cache = /* @__PURE__ */ new WeakMap();
ZodEnum.create = createZodEnum;
var _ZodNativeEnum = class _ZodNativeEnum extends ZodType {
  constructor() {
    super(...arguments);
    _ZodNativeEnum_cache.set(this, void 0);
  }
  _parse(input) {
    const nativeEnumValues = util.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f")) {
      __classPrivateFieldSet(this, _ZodNativeEnum_cache, new Set(util.getValidEnumValues(this._def.values)), "f");
    }
    if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f").has(input.data)) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
};
__name(_ZodNativeEnum, "ZodNativeEnum");
var ZodNativeEnum = _ZodNativeEnum;
_ZodNativeEnum_cache = /* @__PURE__ */ new WeakMap();
ZodNativeEnum.create = (values, params) => {
  return new ZodNativeEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
    ...processCreateParams(params)
  });
};
var _ZodPromise = class _ZodPromise extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(promisified.then((data) => {
      return this._def.type.parseAsync(data, {
        path: ctx.path,
        errorMap: ctx.common.contextualErrorMap
      });
    }));
  }
};
__name(_ZodPromise, "ZodPromise");
var ZodPromise = _ZodPromise;
ZodPromise.create = (schema, params) => {
  return new ZodPromise({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise,
    ...processCreateParams(params)
  });
};
var _ZodEffects = class _ZodEffects extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const effect = this._def.effect || null;
    const checkCtx = {
      addIssue: /* @__PURE__ */ __name((arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status.abort();
        } else {
          status.dirty();
        }
      }, "addIssue"),
      get path() {
        return ctx.path;
      }
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect.type === "preprocess") {
      const processed = effect.transform(ctx.data, checkCtx);
      if (ctx.common.async) {
        return Promise.resolve(processed).then(async (processed2) => {
          if (status.value === "aborted")
            return INVALID;
          const result = await this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx
          });
          if (result.status === "aborted")
            return INVALID;
          if (result.status === "dirty")
            return DIRTY(result.value);
          if (status.value === "dirty")
            return DIRTY(result.value);
          return result;
        });
      } else {
        if (status.value === "aborted")
          return INVALID;
        const result = this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx
        });
        if (result.status === "aborted")
          return INVALID;
        if (result.status === "dirty")
          return DIRTY(result.value);
        if (status.value === "dirty")
          return DIRTY(result.value);
        return result;
      }
    }
    if (effect.type === "refinement") {
      const executeRefinement = /* @__PURE__ */ __name((acc) => {
        const result = effect.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result);
        }
        if (result instanceof Promise) {
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return acc;
      }, "executeRefinement");
      if (ctx.common.async === false) {
        const inner = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inner.status === "aborted")
          return INVALID;
        if (inner.status === "dirty")
          status.dirty();
        executeRefinement(inner.value);
        return { status: status.value, value: inner.value };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status.dirty();
          return executeRefinement(inner.value).then(() => {
            return { status: status.value, value: inner.value };
          });
        });
      }
    }
    if (effect.type === "transform") {
      if (ctx.common.async === false) {
        const base = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (!isValid(base))
          return base;
        const result = effect.transform(base.value, checkCtx);
        if (result instanceof Promise) {
          throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return { status: status.value, value: result };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
          if (!isValid(base))
            return base;
          return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
        });
      }
    }
    util.assertNever(effect);
  }
};
__name(_ZodEffects, "ZodEffects");
var ZodEffects = _ZodEffects;
ZodEffects.create = (schema, effect, params) => {
  return new ZodEffects({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect,
    ...processCreateParams(params)
  });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
  return new ZodEffects({
    schema,
    effect: { type: "preprocess", transform: preprocess },
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    ...processCreateParams(params)
  });
};
var _ZodOptional = class _ZodOptional extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.undefined) {
      return OK(void 0);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
__name(_ZodOptional, "ZodOptional");
var ZodOptional = _ZodOptional;
ZodOptional.create = (type, params) => {
  return new ZodOptional({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional,
    ...processCreateParams(params)
  });
};
var _ZodNullable = class _ZodNullable extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
__name(_ZodNullable, "ZodNullable");
var ZodNullable = _ZodNullable;
ZodNullable.create = (type, params) => {
  return new ZodNullable({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable,
    ...processCreateParams(params)
  });
};
var _ZodDefault = class _ZodDefault extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
__name(_ZodDefault, "ZodDefault");
var ZodDefault = _ZodDefault;
ZodDefault.create = (type, params) => {
  return new ZodDefault({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : () => params.default,
    ...processCreateParams(params)
  });
};
var _ZodCatch = class _ZodCatch extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = {
      ...ctx,
      common: {
        ...ctx.common,
        issues: []
      }
    };
    const result = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: {
        ...newCtx
      }
    });
    if (isAsync(result)) {
      return result.then((result2) => {
        return {
          status: "valid",
          value: result2.status === "valid" ? result2.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      });
    } else {
      return {
        status: "valid",
        value: result.status === "valid" ? result.value : this._def.catchValue({
          get error() {
            return new ZodError(newCtx.common.issues);
          },
          input: newCtx.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
};
__name(_ZodCatch, "ZodCatch");
var ZodCatch = _ZodCatch;
ZodCatch.create = (type, params) => {
  return new ZodCatch({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
    ...processCreateParams(params)
  });
};
var _ZodNaN = class _ZodNaN extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
};
__name(_ZodNaN, "ZodNaN");
var ZodNaN = _ZodNaN;
ZodNaN.create = (params) => {
  return new ZodNaN({
    typeName: ZodFirstPartyTypeKind.ZodNaN,
    ...processCreateParams(params)
  });
};
var BRAND = Symbol("zod_brand");
var _ZodBranded = class _ZodBranded extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data = ctx.data;
    return this._def.type._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  unwrap() {
    return this._def.type;
  }
};
__name(_ZodBranded, "ZodBranded");
var ZodBranded = _ZodBranded;
var _ZodPipeline = class _ZodPipeline extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = /* @__PURE__ */ __name(async () => {
        const inResult = await this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      }, "handleAsync");
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (inResult.status === "aborted")
        return INVALID;
      if (inResult.status === "dirty") {
        status.dirty();
        return {
          status: "dirty",
          value: inResult.value
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }
  static create(a, b) {
    return new _ZodPipeline({
      in: a,
      out: b,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
};
__name(_ZodPipeline, "ZodPipeline");
var ZodPipeline = _ZodPipeline;
var _ZodReadonly = class _ZodReadonly extends ZodType {
  _parse(input) {
    const result = this._def.innerType._parse(input);
    const freeze = /* @__PURE__ */ __name((data) => {
      if (isValid(data)) {
        data.value = Object.freeze(data.value);
      }
      return data;
    }, "freeze");
    return isAsync(result) ? result.then((data) => freeze(data)) : freeze(result);
  }
  unwrap() {
    return this._def.innerType;
  }
};
__name(_ZodReadonly, "ZodReadonly");
var ZodReadonly = _ZodReadonly;
ZodReadonly.create = (type, params) => {
  return new ZodReadonly({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly,
    ...processCreateParams(params)
  });
};
function cleanParams(params, data) {
  const p = typeof params === "function" ? params(data) : typeof params === "string" ? { message: params } : params;
  const p2 = typeof p === "string" ? { message: p } : p;
  return p2;
}
__name(cleanParams, "cleanParams");
function custom(check, _params = {}, fatal) {
  if (check)
    return ZodAny.create().superRefine((data, ctx) => {
      var _a3, _b;
      const r = check(data);
      if (r instanceof Promise) {
        return r.then((r2) => {
          var _a4, _b2;
          if (!r2) {
            const params = cleanParams(_params, data);
            const _fatal = (_b2 = (_a4 = params.fatal) !== null && _a4 !== void 0 ? _a4 : fatal) !== null && _b2 !== void 0 ? _b2 : true;
            ctx.addIssue({ code: "custom", ...params, fatal: _fatal });
          }
        });
      }
      if (!r) {
        const params = cleanParams(_params, data);
        const _fatal = (_b = (_a3 = params.fatal) !== null && _a3 !== void 0 ? _a3 : fatal) !== null && _b !== void 0 ? _b : true;
        ctx.addIssue({ code: "custom", ...params, fatal: _fatal });
      }
      return;
    });
  return ZodAny.create();
}
__name(custom, "custom");
var late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var instanceOfType = /* @__PURE__ */ __name((cls, params = {
  message: `Input not instance of ${cls.name}`
}) => custom((data) => data instanceof cls, params), "instanceOfType");
var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var symbolType = ZodSymbol.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;
var ostring = /* @__PURE__ */ __name(() => stringType().optional(), "ostring");
var onumber = /* @__PURE__ */ __name(() => numberType().optional(), "onumber");
var oboolean = /* @__PURE__ */ __name(() => booleanType().optional(), "oboolean");
var coerce = {
  string: /* @__PURE__ */ __name((arg) => ZodString.create({ ...arg, coerce: true }), "string"),
  number: /* @__PURE__ */ __name((arg) => ZodNumber.create({ ...arg, coerce: true }), "number"),
  boolean: /* @__PURE__ */ __name((arg) => ZodBoolean.create({
    ...arg,
    coerce: true
  }), "boolean"),
  bigint: /* @__PURE__ */ __name((arg) => ZodBigInt.create({ ...arg, coerce: true }), "bigint"),
  date: /* @__PURE__ */ __name((arg) => ZodDate.create({ ...arg, coerce: true }), "date")
};
var NEVER = INVALID;
var z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: errorMap,
  setErrorMap,
  getErrorMap,
  makeIssue,
  EMPTY_PATH,
  addIssueToContext,
  ParseStatus,
  INVALID,
  DIRTY,
  OK,
  isAborted,
  isDirty,
  isValid,
  isAsync,
  get util() {
    return util;
  },
  get objectUtil() {
    return objectUtil;
  },
  ZodParsedType,
  getParsedType,
  ZodType,
  datetimeRegex,
  ZodString,
  ZodNumber,
  ZodBigInt,
  ZodBoolean,
  ZodDate,
  ZodSymbol,
  ZodUndefined,
  ZodNull,
  ZodAny,
  ZodUnknown,
  ZodNever,
  ZodVoid,
  ZodArray,
  ZodObject,
  ZodUnion,
  ZodDiscriminatedUnion,
  ZodIntersection,
  ZodTuple,
  ZodRecord,
  ZodMap,
  ZodSet,
  ZodFunction,
  ZodLazy,
  ZodLiteral,
  ZodEnum,
  ZodNativeEnum,
  ZodPromise,
  ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional,
  ZodNullable,
  ZodDefault,
  ZodCatch,
  ZodNaN,
  BRAND,
  ZodBranded,
  ZodPipeline,
  ZodReadonly,
  custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  coerce,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  "enum": enumType,
  "function": functionType,
  "instanceof": instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  "null": nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean,
  onumber,
  optional: optionalType,
  ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  "undefined": undefinedType,
  union: unionType,
  unknown: unknownType,
  "void": voidType,
  NEVER,
  ZodIssueCode,
  quotelessJson,
  ZodError
});

// src/validators/usuario.ts
var UsuarioSchema = objectType({
  __typename: literalType("Usuario").default("Usuario"),
  id: numberType().int(),
  email: stringType(),
  nome: stringType().nullish(),
  password: stringType().trim(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  deletedAt: dateType().nullish(),
  categoriaId: numberType().int(),
  clienteId: numberType().int().nullish(),
  perfilPermissaoId: numberType().int().nullish()
});

// src/validators/enums.ts
var TipoCertificado = {
  principal: "principal",
  responsavel: "responsavel"
};
var TipoCompensacaoManual2 = {
  COMPENSAR: "COMPENSAR",
  COMPENSADO: "COMPENSADO",
  MESMO_DIA: "MESMO_DIA"
};
var TipoEscalaTrabalho = {
  HORISTA: "HORISTA",
  DIARISTA: "DIARISTA"
};
var ModalidadeContratacao = {
  MENSALISTA: "MENSALISTA",
  HORISTA: "HORISTA"
};
var Ponto = {
  NORMAL: "NORMAL",
  PRE_ASSINALADO: "PRE_ASSINALADO",
  EXCECAO: "EXCECAO",
  SEM_INTERVALO: "SEM_INTERVALO"
};
var PrioridadeCompensacao = {
  maior: "maior",
  menor: "menor"
};
var TipoOcorrencia2 = {
  FOLGA: "FOLGA",
  AFASTAMENTO: "AFASTAMENTO",
  COMPENSACAO: "COMPENSACAO",
  AMAMENTACAO: "AMAMENTACAO"
};
var HistoricoLogStatus = {
  OK: "OK",
  ERRO: "ERRO"
};
var Variante = {
  info: "info",
  success: "success",
  warning: "warning",
  error: "error"
};
var Periodicidade = {
  weekly: "weekly",
  biweekly: "biweekly",
  monthly: "monthly",
  bimonthly: "bimonthly",
  quarterly: "quarterly",
  biannual: "biannual",
  yearly: "yearly"
};
var SN2 = {
  S: "S",
  N: "N"
};
var Sexo2 = {
  M: "M",
  F: "F"
};
var Status2 = {
  PENDENTE: "PENDENTE",
  PROCESSANDO: "PROCESSANDO",
  CONCLUIDO: "CONCLUIDO",
  INCOMPLETO: "INCOMPLETO",
  ERRO: "ERRO"
};
var StatusCompetencia2 = {
  ABERTA: "ABERTA",
  FECHADA: "FECHADA"
};
var StatusAprovacao2 = {
  PENDENTE: "PENDENTE",
  APROVADO: "APROVADO",
  REPROVADO: "REPROVADO",
  PENDENTE_EXCLUSAO: "PENDENTE_EXCLUSAO"
};
var LayoutFolha2 = {
  DOMINIO: "DOMINIO",
  DOMINIO_DECIMAL: "DOMINIO_DECIMAL",
  FORTES_5: "FORTES_5",
  FORTES_6: "FORTES_6",
  QUESTOR_01: "QUESTOR_01",
  QUESTOR_02: "QUESTOR_02",
  QUESTOR_03: "QUESTOR_03",
  SYSTEM: "SYSTEM",
  DATA_CEMPRO: "DATA_CEMPRO",
  VIASOFT: "VIASOFT"
};
var TipoDescontoDSR2 = {
  NAO_DESCONTAR: "NAO_DESCONTAR",
  FALTA_INTEGRAL: "FALTA_INTEGRAL",
  TURNO: "TURNO",
  ATRASO: "ATRASO"
};
var TipoAbono = {
  NORMAL: "NORMAL",
  SAUDE_OCUPACIONAL: "SAUDE_OCUPACIONAL"
};
var TipoHorasExcedentes = {
  DIARIO: "DIARIO",
  SEMANAL: "SEMANAL",
  MENSAL: "MENSAL"
};
var TipoTabelaHorario = {
  DIARIA: "DIARIA",
  SEMANAL: "SEMANAL"
};
var TipoRepeticao = {
  DIARIO: "DIARIO",
  SEMANAL: "SEMANAL",
  MENSAL: "MENSAL"
};
var RepeticaoMensalOpcao = {
  DIA: "DIA",
  SEMANA: "SEMANA"
};
var TipoDocumentoEmpresa = {
  CPF: "CPF",
  CNPJ: "CNPJ",
  CAEPF: "CAEPF"
};
var TipoCompensacaoDia2 = {
  FERIADO: "FERIADO",
  FOLGA: "FOLGA"
};

// src/validators/avaliacao.ts
var AvaliacaoSchema = objectType({
  __typename: literalType("Avaliacao").default("Avaliacao"),
  id: numberType().int(),
  email: stringType(),
  cnpj: stringType().nullish(),
  nomeResponsavel: stringType(),
  telefone: stringType(),
  dtFimAvaliacao: dateType(),
  virouCliente: nativeEnumType(SN2).nullish(),
  funcaoId: numberType().int(),
  clienteId: numberType().int(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/funcoes_avaliacao.ts
var FuncoesAvaliacaoSchema = objectType({
  __typename: literalType("FuncoesAvaliacao").default("FuncoesAvaliacao"),
  id: numberType().int(),
  nome: stringType()
});

// src/validators/parametros_avaliacao.ts
var ParametrosAvaliacaoSchema = objectType({
  __typename: literalType("ParametrosAvaliacao").default("ParametrosAvaliacao"),
  id: numberType().int(),
  diasAvaliacao: numberType().int(),
  estenderDias: numberType().int(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/helpers/index.ts
var helpers_exports = {};
__export(helpers_exports, {
  dateRegex: () => dateRegex2,
  fromJson: () => fromJson,
  isCPF: () => isCPF,
  isCaepfValido: () => isCaepfValido,
  isCep: () => isCep,
  isCnpjValido: () => isCnpjValido,
  isDocumentoEmpresaValido: () => isDocumentoEmpresaValido,
  removeMask: () => removeMask,
  schemaSN: () => schemaSN,
  toDate: () => toDate,
  toJson: () => toJson,
  toSN: () => toSN,
  transformPis: () => transformPis
});
import { cpfValido, isCaepfValido, isCnpjValido } from "@acme/common";

// src/helpers/toDate.ts
var valueValidRegex = /^(\d{4})-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
var dateStringRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
var toDate = /* @__PURE__ */ __name((value) => {
  if (typeof value === "string") {
    if (valueValidRegex.test(value)) return /* @__PURE__ */ new Date(`${value}T00:00:00.000Z`);
    if (dateStringRegex.test(value)) return new Date(value);
  }
  if (value instanceof Date) {
    return new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), 0, 0, 0, 0));
  }
  throw new Error(`Data inv\xE1lida: ${value}`);
}, "toDate");

// src/helpers/toSN.ts
var toSN = /* @__PURE__ */ __name((value) => {
  if (value === null) return;
  const tipo = typeof value;
  switch (tipo) {
    case "string":
      return value === "S" ? "S" : "N";
    case "number":
      return value === 1 ? "S" : "N";
    case "boolean":
      return value ? "S" : "N";
    default:
      return "N";
  }
}, "toSN");

// src/helpers/index.ts
var isCPF = cpfValido;
var removeMask = /* @__PURE__ */ __name((value) => value.replace(/\D/g, ""), "removeMask");
var dateRegex2 = valueValidRegex;
var transformPis = /* @__PURE__ */ __name((value) => {
  if (typeof value === "number") return value.toString();
  return removeMask(value);
}, "transformPis");
var isCep = /* @__PURE__ */ __name((value) => value.replace(/\D/g, "").length === 8, "isCep");
function isDocumentoEmpresaValido(value) {
  return isCnpjValido(value) || isCaepfValido(value) || isCPF(value);
}
__name(isDocumentoEmpresaValido, "isDocumentoEmpresaValido");
var toJson = /* @__PURE__ */ __name((value) => JSON.stringify(value), "toJson");
var fromJson = /* @__PURE__ */ __name((value) => JSON.parse(value), "fromJson");
var schemaSN = z.boolean().or(z.enum([
  "S",
  "N"
])).transform(toSN);

// src/validators/cliente.ts
var ClienteSchema = objectType({
  __typename: literalType("Cliente").default("Cliente"),
  id: numberType().int(),
  razaoSocial: stringType().nullish(),
  nomeFantasia: stringType(),
  cnpj: stringType().nullish(),
  dataLiberacao: dateType().nullish(),
  exportarFolhaFormatoHoras: stringType().nullish(),
  nomeResponsavel: stringType(),
  telefoneResponsavel: stringType(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  privacidadeAceitoData: dateType().nullish(),
  termoAceitoData: dateType().nullish(),
  myId: stringType().nullish(),
  subscriptionMyId: stringType().nullish(),
  criadorId: numberType().int().nullish(),
  dtFimAtivacao: dateType().optional(),
  emailContato: stringType().nullish(),
  nomeContato: stringType().nullish(),
  telefoneContato: stringType().nullish(),
  suporteIntegrado: schemaSN.optional(),
  limiteFuncionarios: numberType().int().optional(),
  segmentoId: numberType().int().nullish()
});

// src/validators/cartao.ts
var CartaoSchema = objectType({
  __typename: literalType("Cartao").default("Cartao"),
  id: numberType().int(),
  clienteId: numberType().int(),
  myId: stringType(),
  nome: stringType(),
  isBackup: booleanType().optional(),
  createdAt: dateType().optional()
});

// src/validators/plano_diferenciado.ts
var PlanoDiferenciadoSchema = objectType({
  __typename: literalType("PlanoDiferenciado").default("PlanoDiferenciado"),
  clienteId: numberType().int(),
  periodicidade: stringType(),
  valorCentavos: numberType().int(),
  limiteFuncionarios: numberType().int()
});

// src/validators/plano.ts
var PlanoSchema = objectType({
  __typename: literalType("Plano").default("Plano"),
  id: numberType().int(),
  periodicidade: nativeEnumType(Periodicidade),
  limiteFuncionarios: numberType().int(),
  precoCentavos: numberType().int(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/segmento.ts
var SegmentoSchema = objectType({
  __typename: literalType("Segmento").default("Segmento"),
  id: numberType().int(),
  nome: stringType(),
  usuarioId: numberType().int().nullish(),
  createdAt: dateType().optional()
});

// src/validators/empresa.ts
var EmpresaSchema = objectType({
  __typename: literalType("Empresa").default("Empresa"),
  id: numberType().int(),
  documento: stringType().min(1, {
    message: "Obrigat\xF3rio"
  }).nullish(),
  tipoDocumento: nativeEnumType(TipoDocumentoEmpresa).nullish(),
  razaoSocial: stringType().nullish(),
  nomeFantasia: stringType().min(1, {
    message: "Obrigat\xF3rio"
  }),
  telefoneResponsavel: stringType().min(1, {
    message: "Obrigat\xF3rio"
  }).nullish(),
  email: stringType().min(1, {
    message: "Obrigat\xF3rio"
  }),
  telefone: stringType().nullish(),
  cidadeId: numberType().int().nullish(),
  segmentoId: numberType().int().nullish(),
  bairro: stringType().min(1, {
    message: "Obrigat\xF3rio"
  }).nullish(),
  endereco: stringType().min(1, {
    message: "Obrigat\xF3rio"
  }).nullish(),
  numero: coerce.string().min(1, {
    message: "Obrigat\xF3rio"
  }).nullish(),
  cei: stringType().nullish(),
  cno: stringType().nullish(),
  competenciaAtual: stringType().min(1, {
    message: "Obrigat\xF3rio"
  }).nullish(),
  diaInicioPonto: coerce.number().int().nullish(),
  codEmpresaFolha: coerce.number().int().nullish(),
  descricaoAutorizacao: stringType().nullish(),
  toleranciaDiariaFalta: stringType().nullish(),
  diasToleranciaMes: coerce.number().int().nullish(),
  limiteAlteracaoRegistro: coerce.number().int().nullish(),
  repsConectados: coerce.number().int().nullish(),
  totalFuncionarios: coerce.number().int().nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  deletedAt: dateType().nullish(),
  nomeResponsavel: stringType().min(1, {
    message: "Obrigat\xF3rio"
  }).nullish(),
  clienteId: numberType().int(),
  celular: stringType().nullish(),
  periodoFechamentoPonto: coerce.number().int().nullish(),
  proximoFechamentoPonto: coerce.string().nullish(),
  cep: coerce.string().min(1, {
    message: "Obrigat\xF3rio"
  }).refine(isCep, {
    message: "CEP inv\xE1lido"
  }).transform(removeMask).nullish(),
  diasRescisao: coerce.number().int().optional(),
  layoutFolha: nativeEnumType(LayoutFolha2).optional(),
  hrCalculoAutomatico: stringType({
    invalid_type_error: "Selecione uma hora"
  }).nullish(),
  buscarFechamentoRegistroAte: coerce.number().int().max(23).min(0).default(7).optional(),
  dsrDescontaFeriado: schemaSN.optional(),
  dsrExibeHoras: schemaSN.optional(),
  tipoDescontoDSR: nativeEnumType(TipoDescontoDSR2).optional(),
  atrasoDescontoDSR: stringType().nullish(),
  cpfResponsavel: stringType().refine(isCPF, {
    message: "CPF inv\xE1lido"
  }).transform(removeMask).nullish(),
  ocultarInfoRodapeEspelho: schemaSN.optional(),
  exportarHorasFaltaJustificada: schemaSN.optional(),
  faltaJustificadaDescontaDSR: schemaSN.optional(),
  exibirSaldoDiario: schemaSN.optional(),
  mensagemAniversario: stringType().nullish(),
  justificativaPadraoRegistro: stringType().trim().nullish(),
  periodoDescontoDSR: nativeEnumType(RepeticaoMensalOpcao).optional(),
  inicioSemana: coerce.number().min(0).max(6).int().optional(),
  exportarHorasFaltaIntegral: schemaSN.optional(),
  esconderLinhasOndeNaoTrabalha: schemaSN.optional()
});

// src/validators/troca_inicio_ponto.ts
var TrocaInicioPontoSchema = objectType({
  __typename: literalType("TrocaInicioPonto").default("TrocaInicioPonto"),
  id: numberType().int(),
  diaAnterior: numberType().int(),
  diaInicioPonto: numberType().int(),
  empresaId: numberType().int(),
  competencia: stringType(),
  dataInicial: dateType(),
  dataFinal: dateType(),
  createdAt: dateType().optional()
});

// src/validators/funcionario.ts
var FuncionarioSchema = objectType({
  __typename: literalType("Funcionario").default("Funcionario"),
  id: numberType().int(),
  empresaId: numberType().int(),
  nome: stringType().min(1, {
    message: "Obrigat\xF3rio"
  }),
  pis: unionType([
    stringType(),
    numberType()
  ]).transform(transformPis),
  matricula: coerce.number().int(),
  matriculaFolha: numberType().int().nullish(),
  dtNascimento: coerce.string().transform(toDate).nullish(),
  sexo: nativeEnumType(Sexo2).nullish(),
  nomeSocial: stringType().nullish(),
  regraCalculo: numberType().int(),
  dtAdmissao: coerce.string().transform(toDate).nullish(),
  dtRescisao: coerce.string().transform(toDate).nullish(),
  cidadeTrabalho: numberType().int().nullish(),
  cpf: stringType().refine(isCPF, {
    message: "CPF inv\xE1lido"
  }).transform(removeMask).nullish(),
  expFolhaHorasExtras: schemaSN.optional(),
  expFolhaFaltas: schemaSN.optional(),
  expFolhaAdicionalNoturno: schemaSN.optional(),
  expFolhaHorasTrabalhar: schemaSN.optional(),
  horarioNoturno: schemaSN.optional(),
  repCodigo: coerce.string().nullish(),
  repProximidade: coerce.string().nullish(),
  repCodBarras: coerce.string().nullish(),
  repSenha: coerce.string().nullish(),
  repSupervisor: coerce.string().nullish(),
  registroApp: schemaSN.optional(),
  registroWeb: schemaSN.optional(),
  ajustesPonto: schemaSN.optional(),
  verSaldoHoras: schemaSN.optional(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  deletedAt: dateType().nullish(),
  reconhecimentoFacial: coerce.number().int().optional(),
  funcionarioPontoWebId: coerce.number().int().nullish(),
  usuarioId: coerce.number().int().optional(),
  pontoDiferenciado: nativeEnumType(Ponto).optional(),
  bonusValeAlimentacao: coerce.number().nullish().optional(),
  modalidadeContratacao: nativeEnumType(ModalidadeContratacao).optional(),
  entradaDiaSeguinte: stringType().nullish(),
  recebeValeAlimentacao: schemaSN.optional(),
  desconsiderarFeriados: schemaSN.optional(),
  funcao: stringType().optional(),
  expFolhaHorasNormais: schemaSN.optional()
});

// src/validators/tabela_horario.ts
var literalSchema = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
var jsonSchema = lazyType(() => unionType([
  literalSchema,
  arrayType(jsonSchema),
  recordType(jsonSchema)
]));
var TabelaHorarioSchema = objectType({
  __typename: literalType("TabelaHorario").default("TabelaHorario"),
  id: numberType().int(),
  clienteId: numberType().int(),
  nome: stringType(),
  codigo: numberType().int().nullish(),
  entradaAntes: stringType().nullish(),
  entradaDepois: stringType().nullish(),
  saidaAntes: stringType().nullish(),
  saidaDepois: stringType().nullish(),
  toleranciaTurno: stringType().optional(),
  toleranciaDia: stringType().optional(),
  domEnt1: stringType().nullish(),
  domSai1: stringType().nullish(),
  domEnt2: stringType().nullish(),
  domSai2: stringType().nullish(),
  domEnt3: stringType().nullish(),
  domSai3: stringType().nullish(),
  segEnt1: stringType().nullish(),
  segSai1: stringType().nullish(),
  segEnt2: stringType().nullish(),
  segSai2: stringType().nullish(),
  segEnt3: stringType().nullish(),
  segSai3: stringType().nullish(),
  terEnt1: stringType().nullish(),
  terSai1: stringType().nullish(),
  terEnt2: stringType().nullish(),
  terSai2: stringType().nullish(),
  terEnt3: stringType().nullish(),
  terSai3: stringType().nullish(),
  quaEnt1: stringType().nullish(),
  quaSai1: stringType().nullish(),
  quaEnt2: stringType().nullish(),
  quaSai2: stringType().nullish(),
  quaEnt3: stringType().nullish(),
  quaSai3: stringType().nullish(),
  quiEnt1: stringType().nullish(),
  quiSai1: stringType().nullish(),
  quiEnt2: stringType().nullish(),
  quiSai2: stringType().nullish(),
  quiEnt3: stringType().nullish(),
  quiSai3: stringType().nullish(),
  sexEnt1: stringType().nullish(),
  sexSai1: stringType().nullish(),
  sexEnt2: stringType().nullish(),
  sexSai2: stringType().nullish(),
  sexEnt3: stringType().nullish(),
  sexSai3: stringType().nullish(),
  sabEnt1: stringType().nullish(),
  sabSai1: stringType().nullish(),
  sabEnt2: stringType().nullish(),
  sabSai2: stringType().nullish(),
  sabEnt3: stringType().nullish(),
  sabSai3: stringType().nullish(),
  domTra: nativeEnumType(SN2).nullish(),
  domTot: stringType().nullish(),
  segTot: stringType().nullish(),
  terTot: stringType().nullish(),
  quaTot: stringType().nullish(),
  quiTot: stringType().nullish(),
  sexTot: stringType().nullish(),
  sabTot: stringType().nullish(),
  tolTur: stringType().nullish(),
  totSem: stringType().nullish(),
  toleranciaSemana: stringType().optional(),
  limiteDiario: stringType().nullish(),
  intervaloAposHoras: stringType().nullish(),
  intervaloDesconto: stringType().nullish(),
  tipo: nativeEnumType(TipoTabelaHorario).optional(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  deletedAt: dateType().nullish(),
  diaDescontoDSR: coerce.number().int().optional(),
  previewEspelho: jsonSchema.nullish(),
  maximoPausas: coerce.number().int().optional(),
  pausasAcumulam: schemaSN.optional(),
  tempoPausas: stringType().optional(),
  faltaPausas: schemaSN.optional(),
  horasExtraPausas: schemaSN.optional(),
  horasIntervalares: stringType().nullish()
});

// src/validators/regras_calculo.ts
var RegrasCalculoSchema = objectType({
  __typename: literalType("RegrasCalculo").default("RegrasCalculo"),
  id: numberType().int(),
  nome: stringType(),
  segQtdPrimeirasHrs: stringType(),
  segPorcentagemPrimeirasHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  segPorcentagemDemaisHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  terQtdPrimeirasHrs: stringType(),
  terPorcentagemPrimeirasHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  terPorcentagemDemaisHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  quaQtdPrimeirasHrs: stringType(),
  quaPorcentagemPrimeirasHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  quaPorcentagemDemaisHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  quiQtdPrimeirasHrs: stringType(),
  quiPorcentagemPrimeirasHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  quiPorcentagemDemaisHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  sexQtdPrimeirasHrs: stringType(),
  sexPorcentagemPrimeirasHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  sexPorcentagemDemaisHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  sabQtdPrimeirasHrs: stringType(),
  sabPorcentagemPrimeirasHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  sabPorcentagemDemaisHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  domQtdPrimeirasHrs: stringType(),
  domPorcentagemPrimeirasHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  domPorcentagemDemaisHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  ferQtdPrimeirasHrs: stringType(),
  ferPorcentagemPrimeirasHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  ferPorcentagemDemaisHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  deletedAt: dateType().nullish(),
  clienteId: numberType().int(),
  adicionalNoturno: numberType().optional(),
  domPrioridadeCompensacao: nativeEnumType(PrioridadeCompensacao).optional(),
  ferPrioridadeCompensacao: nativeEnumType(PrioridadeCompensacao).optional(),
  quaPrioridadeCompensacao: nativeEnumType(PrioridadeCompensacao).optional(),
  quiPrioridadeCompensacao: nativeEnumType(PrioridadeCompensacao).optional(),
  sabPrioridadeCompensacao: nativeEnumType(PrioridadeCompensacao).optional(),
  segPrioridadeCompensacao: nativeEnumType(PrioridadeCompensacao).optional(),
  sexPrioridadeCompensacao: nativeEnumType(PrioridadeCompensacao).optional(),
  terPrioridadeCompensacao: nativeEnumType(PrioridadeCompensacao).optional(),
  compensarInjustificadas: schemaSN.optional(),
  compensarJustificadas: schemaSN.optional(),
  horasExtrasFeriado: schemaSN.optional(),
  compensacaoDeHoras: schemaSN.optional(),
  toleranciaCLT: schemaSN.optional(),
  controlarBancoHoras: schemaSN.optional(),
  /**
  * Competência (YYYY-MM) a partir da qual o banco de horas passa a valer. Inclusiva.
  */
  inicioBancoHoras: stringType().nullish(),
  /**
  * Última competência (YYYY-MM) em que o banco de horas vale. Inclusiva.
  */
  fimBancoHoras: stringType().nullish(),
  hrsExtrasNoturnas: schemaSN.optional(),
  compensarHrsExtrasNoturnas: schemaSN.optional(),
  compensacaoFifo: schemaSN.optional(),
  tipoHorasExcedentes: nativeEnumType(TipoHorasExcedentes).optional(),
  domControleTurno: schemaSN.optional(),
  ferControleTurno: schemaSN.optional(),
  quaControleTurno: schemaSN.optional(),
  quiControleTurno: schemaSN.optional(),
  sabControleTurno: schemaSN.optional(),
  segControleTurno: schemaSN.optional(),
  sexControleTurno: schemaSN.optional(),
  terControleTurno: schemaSN.optional(),
  mensalPorcentagemDemaisHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  mensalPorcentagemPrimeirasHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  mensalPrioridadeCompensacao: nativeEnumType(PrioridadeCompensacao).optional(),
  mensalQtdPrimeirasHrs: stringType().optional(),
  semanalPorcentagemDemaisHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  semanalPorcentagemPrimeirasHrs: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }).nullish(),
  semanalPrioridadeCompensacao: nativeEnumType(PrioridadeCompensacao).optional(),
  semanalQtdPrimeirasHrs: stringType().optional(),
  horasInterjornada: stringType().optional(),
  calcularHorasSuprimidas: schemaSN.optional(),
  faltaAutomatica: stringType().nullish(),
  horasFaltaAutomatica: stringType().nullish(),
  compensacaoManual: schemaSN.optional(),
  horasExcedentesConsideraDiaInteiro: schemaSN.optional(),
  segMaximoHorasDiarias: stringType().nullish(),
  terMaximoHorasDiarias: stringType().nullish(),
  quaMaximoHorasDiarias: stringType().nullish(),
  quiMaximoHorasDiarias: stringType().nullish(),
  sexMaximoHorasDiarias: stringType().nullish(),
  sabMaximoHorasDiarias: stringType().nullish(),
  domMaximoHorasDiarias: stringType().nullish(),
  ferMaximoHorasDiarias: stringType().nullish(),
  horarioEncerramentoAdicionalNoturno: stringType().nullish(),
  horarioInicioAdicionalNoturno: stringType().optional(),
  horarioFimAdicionalNoturno: stringType().optional(),
  temAdicionalNoturno: schemaSN.optional(),
  reducaoHrsATrabalhar: schemaSN.optional(),
  reducaoAdicionalNoturno: schemaSN.optional()
});

// src/validators/porcentagens_regra_calculo.ts
var PorcentagensRegraCalculoSchema = objectType({
  __typename: literalType("PorcentagensRegraCalculo").default("PorcentagensRegraCalculo"),
  id: numberType().int(),
  regraCalculoId: numberType().int(),
  porcentagem: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  exportar: nativeEnumType(SN2).optional(),
  persiste: booleanType().optional(),
  compensacao: numberType().int()
});

// src/validators/centro_custo.ts
var CentroCustoSchema = objectType({
  __typename: literalType("CentroCusto").default("CentroCusto"),
  id: numberType().int(),
  nomeCentroCusto: stringType(),
  codigo: stringType(),
  empresaId: numberType().int(),
  predecessorId: numberType().int().nullish(),
  updatedAt: dateType().optional(),
  createdAt: dateType().optional(),
  deletedAt: dateType().nullish()
});

// src/validators/funcionario_centro_custo.ts
var FuncionarioCentroCustoSchema = objectType({
  __typename: literalType("FuncionarioCentroCusto").default("FuncionarioCentroCusto"),
  id: numberType().int(),
  funcionarioId: numberType().int(),
  centroCustoId: numberType().int(),
  dtInicial: coerce.string().transform(toDate),
  dtFinal: coerce.string().transform(toDate).nullish(),
  createdAt: dateType().optional(),
  deletedAt: dateType().nullish()
});

// src/validators/feriados_nacionais_estaduais.ts
var FeriadosNacionaisEstaduaisSchema = objectType({
  __typename: literalType("FeriadosNacionaisEstaduais").default("FeriadosNacionaisEstaduais"),
  id: numberType().int(),
  dia: numberType().int(),
  mes: numberType().int(),
  nome: stringType(),
  uf: stringType().nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  ano: numberType().int().nullish()
});

// src/validators/feriados_cliente.ts
var FeriadosClienteSchema = objectType({
  __typename: literalType("FeriadosCliente").default("FeriadosCliente"),
  id: numberType().int(),
  clienteId: numberType().int(),
  dia: numberType().int(),
  mes: numberType().int(),
  nome: stringType(),
  cidadeId: numberType().int(),
  uf: stringType(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  ano: numberType().int().nullish()
});

// src/validators/treinamento.ts
var TreinamentoSchema = objectType({
  __typename: literalType("Treinamento").default("Treinamento"),
  id: numberType().int(),
  clienteId: numberType().int(),
  data: dateType(),
  quemRecebeu: stringType(),
  usuarioId: numberType().int(),
  observacao: stringType().nullish(),
  cobranca: booleanType().optional(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/cidade.ts
var CidadeSchema = objectType({
  __typename: literalType("Cidade").default("Cidade"),
  id: numberType().int(),
  ibge: coerce.number().int(),
  cidade: stringType(),
  uf: stringType(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/local.ts
var LocalSchema = objectType({
  __typename: literalType("Local").default("Local"),
  id: numberType().int(),
  empresaId: numberType().int(),
  nomeLocal: stringType(),
  endereco: stringType().nullish(),
  latitude: coerce.string(),
  longitude: coerce.string(),
  cercaEletronica: stringType(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/funcionario_locais.ts
var FuncionarioLocaisSchema = objectType({
  __typename: literalType("FuncionarioLocais").default("FuncionarioLocais"),
  id: numberType().int(),
  funcionarioId: numberType().int(),
  localId: numberType().int(),
  createdAt: dateType().optional()
});

// src/validators/marca.ts
var MarcaSchema = objectType({
  __typename: literalType("Marca").default("Marca"),
  id: numberType().int(),
  nome: stringType(),
  createdAt: dateType().optional(),
  imagemRep: stringType().nullish(),
  integrador: stringType().nullish(),
  manualUsuario: stringType().nullish()
});

// src/validators/rep.ts
var RepSchema = objectType({
  __typename: literalType("Rep").default("Rep"),
  id: numberType().int(),
  empresaId: numberType().int(),
  marcaId: coerce.number().int(),
  ip: stringType().nullish(),
  porta: stringType().nullish(),
  usuario: stringType().nullish(),
  senha: stringType().nullish(),
  numeroSerie: stringType().nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  ultimoNsr: coerce.number().int().nullish(),
  dataInicial: stringType().nullish(),
  nome: stringType().nullish(),
  portaria671: booleanType().transform(toSN).optional()
});

// src/validators/registro.ts
var RegistroSchema = objectType({
  __typename: literalType("Registro").default("Registro"),
  id: numberType().int(),
  funcionarioId: numberType().int(),
  hora: stringType(),
  data: coerce.string().transform(toDate),
  origem: numberType().int(),
  nsr: numberType().int().nullish(),
  empresaId: numberType().int(),
  repId: numberType().int().nullish(),
  localId: numberType().int().nullish(),
  createdAt: dateType().optional(),
  deletedAt: dateType().nullish(),
  justificativa: stringType().max(190).optional(),
  statusAprovacao: nativeEnumType(StatusAprovacao2).optional(),
  fileUrl: stringType().nullish(),
  deviceBrand: stringType().nullish(),
  deviceModel: stringType().nullish(),
  deviceName: stringType().nullish(),
  latitude: stringType().nullish(),
  longitude: stringType().nullish(),
  distanciaRegistro: stringType().nullish(),
  hash: stringType().nullish(),
  online_offline: numberType().int().nullish(),
  internetAlcancavel: stringType().nullish(),
  metodoRegistro: stringType().nullish(),
  relativeTime: numberType().int().nullish(),
  tipoRede: stringType().nullish(),
  wifiHabilitada: stringType().nullish(),
  dentroCerca: nativeEnumType(SN2).nullish(),
  updatedAt: dateType().optional(),
  espelhoPontoId: numberType().int().nullish(),
  transactionID: stringType().nullish(),
  criadorId: numberType().int().nullish(),
  parentId: numberType().int().nullish(),
  saidaDiaAnterior: nativeEnumType(SN2).nullish().optional(),
  entradaDiaSeguinte: nativeEnumType(SN2).optional()
});

// src/validators/endereco.ts
var EnderecoSchema = objectType({
  __typename: literalType("Endereco").default("Endereco"),
  nomeFormatado: stringType(),
  latitude: stringType(),
  longitude: stringType()
});

// src/validators/motivo_exclusao.ts
var MotivoExclusaoSchema = objectType({
  __typename: literalType("MotivoExclusao").default("MotivoExclusao"),
  id: numberType().int(),
  empresaId: numberType().int(),
  registroId: numberType().int().nullish(),
  abonoId: numberType().int().nullish(),
  afastamentoId: numberType().int().nullish(),
  compensacaoDiaId: numberType().int().nullish(),
  faltaId: numberType().int().nullish(),
  motivo: stringType(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/abono.ts
var AbonoSchema = objectType({
  __typename: literalType("Abono").default("Abono"),
  id: numberType().int(),
  empresaId: numberType().int(),
  funcionarioId: numberType().int(),
  data: coerce.string().transform(toDate),
  quantidadeHoras: stringType(),
  justificativa: stringType().max(190).nullish(),
  fileUrl: stringType().nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  deletedAt: dateType().nullish(),
  origem: numberType().int(),
  statusAprovacao: nativeEnumType(StatusAprovacao2).optional(),
  tipo: nativeEnumType(TipoAbono).optional(),
  descricao: stringType().max(30).nullish(),
  criadorId: numberType().int().nullish()
});

// src/validators/compensacao_dia.ts
var CompensacaoDiaSchema = objectType({
  __typename: literalType("CompensacaoDia").default("CompensacaoDia"),
  id: numberType().int(),
  empresaId: numberType().int(),
  funcionarioId: numberType().int(),
  dataFeriado: coerce.string().transform(toDate),
  dataCompensacao: coerce.string().transform(toDate),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  deletedAt: dateType().nullish(),
  tipo: nativeEnumType(TipoCompensacaoDia2).optional()
});

// src/validators/ocorrencia.ts
var OcorrenciaSchema = objectType({
  __typename: literalType("Ocorrencia").default("Ocorrencia"),
  id: numberType().int(),
  clienteId: numberType().int(),
  codigo: coerce.number().int(),
  descricao: stringType(),
  tipo: nativeEnumType(TipoOcorrencia2, {
    required_error: "Obrigat\xF3rio"
  }),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  atalho: booleanType().transform(toSN).optional(),
  pagarVale: booleanType().transform(toSN).optional(),
  deletedAt: dateType().nullish(),
  somarAusenciasInjustificadas: booleanType().transform(toSN).optional(),
  somarAusenciasJustificadas: booleanType().transform(toSN).optional(),
  somarHorasTrabalhadas: booleanType().transform(toSN).optional(),
  somarHorasTrabalhar: booleanType().transform(toSN).optional(),
  tempoAmamentacao: stringType().nullish().optional(),
  feriadoNaSemana: booleanType().transform(toSN).optional(),
  qntHrsCompensadasNaSemana: stringType().nullish().optional()
});

// src/validators/rubrica.ts
var RubricaSchema = objectType({
  __typename: literalType("Rubrica").default("Rubrica"),
  id: numberType().int(),
  clienteId: numberType().int(),
  codigo: coerce.number().int(),
  referencia: stringType(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  exportar: schemaSN.optional()
});

// src/validators/excecao_rubrica.ts
var ExcecaoRubricaSchema = objectType({
  __typename: literalType("ExcecaoRubrica").default("ExcecaoRubrica"),
  id: numberType().int(),
  rubricaId: numberType().int(),
  codigo: numberType().int(),
  empresaId: numberType().int().nullish(),
  centroCustoId: numberType().int().nullish(),
  localId: numberType().int().nullish(),
  funcionarioId: numberType().int().nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/afastamento.ts
var AfastamentoSchema = objectType({
  __typename: literalType("Afastamento").default("Afastamento"),
  id: numberType().int(),
  empresaId: numberType().int(),
  funcionarioId: numberType().int(),
  dataInicial: coerce.string().transform(toDate),
  dataFinal: coerce.string().transform(toDate),
  fileUrl: stringType().nullish(),
  ocorrenciaId: numberType().int(),
  justificativa: stringType().max(190).nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  deletedAt: dateType().nullish(),
  origem: numberType().int().optional(),
  statusAprovacao: nativeEnumType(StatusAprovacao2).optional(),
  criadorId: numberType().int().nullish()
});

// src/validators/funcionario_reps.ts
var FuncionarioRepsSchema = objectType({
  __typename: literalType("FuncionarioReps").default("FuncionarioReps"),
  id: numberType().int(),
  funcionarioId: numberType().int(),
  repId: numberType().int(),
  createdAt: dateType().optional()
});

// src/validators/calculo.ts
var literalSchema2 = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
var jsonSchema2 = lazyType(() => unionType([
  literalSchema2,
  arrayType(jsonSchema2),
  recordType(jsonSchema2)
]));
var CalculoSchema = objectType({
  __typename: literalType("Calculo").default("Calculo"),
  id: numberType().int(),
  empresaId: numberType().int(),
  funcionarioId: numberType().int(),
  competencia: stringType(),
  periodo: stringType(),
  totHrsATrabalhar: stringType().optional(),
  totHrsTrabalhadas: stringType().optional(),
  totFaltas: stringType().optional(),
  totAdicNoturno: stringType().optional(),
  totHrsExtras: stringType().optional(),
  totSobreaviso: stringType().optional(),
  porcentagemHrsExtras: jsonSchema2,
  saldoHorasId: numberType().int().nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  historicoCalculoId: numberType().int().nullish(),
  pagamentoHorasId: numberType().int().nullish(),
  totFaltasIntegrais: stringType().optional(),
  totFaltasParciais: stringType().optional(),
  aceito: nativeEnumType(SN2).nullish(),
  dataAceite: dateType().nullish(),
  motivoRecusa: stringType().max(150).nullish(),
  filename: stringType().nullish(),
  totHrsExtrasNoturnas: stringType().optional(),
  porcentagemHrsExtrasNoturnas: jsonSchema2.optional()
});

// src/validators/log_calculos.ts
var LogCalculosSchema = objectType({
  __typename: literalType("LogCalculos").default("LogCalculos"),
  id: numberType().int(),
  visto: booleanType().nullish().optional(),
  competencia: stringType(),
  dia: coerce.string().transform(toDate),
  descricao: stringType(),
  createdAt: dateType().optional(),
  calculoId: numberType().int().nullish(),
  titulo: stringType(),
  variante: nativeEnumType(Variante).optional(),
  empresaId: numberType().int(),
  funcionarioId: numberType().int()
});

// src/validators/espelho_ponto.ts
var literalSchema3 = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
var jsonSchema3 = lazyType(() => unionType([
  literalSchema3,
  arrayType(jsonSchema3),
  recordType(jsonSchema3)
]));
var EspelhoPontoSchema = objectType({
  __typename: literalType("EspelhoPonto").default("EspelhoPonto"),
  id: numberType().int(),
  calculoId: numberType().int(),
  regraCalculoId: numberType().int(),
  data: coerce.string().transform(toDate),
  ent1: stringType().nullish(),
  sai1: stringType().nullish(),
  ent2: stringType().nullish(),
  sai2: stringType().nullish(),
  ent3: stringType().nullish(),
  sai3: stringType().nullish(),
  ent4: stringType().nullish(),
  sai4: stringType().nullish(),
  ent5: stringType().nullish(),
  sai5: stringType().nullish(),
  horasExtra: stringType().optional(),
  porcentagemHrsExtras: jsonSchema3,
  porcentagemHrsExtrasNoturnas: jsonSchema3,
  faltas: stringType().optional(),
  horasTrabalhadas: stringType().optional(),
  adicionalNoturno: stringType().optional(),
  sobreaviso: stringType().optional(),
  sobreavisoId: numberType().int().nullish(),
  afastamentoId: numberType().int().nullish(),
  compensacaoDiaId: numberType().int().nullish(),
  horasAbonadas: stringType().optional(),
  abonoId: numberType().int().nullish(),
  empresaId: numberType().int().nullish(),
  competencia: stringType().nullish(),
  funcionarioId: numberType().int().nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  excecaoValeRefeicao: nativeEnumType(SN2).optional(),
  feriadoClienteId: numberType().int().nullish(),
  feriadoNacionalId: numberType().int().nullish(),
  origens: jsonSchema3,
  faltaCadastradaId: numberType().int().nullish(),
  folgaId: numberType().int().nullish(),
  horasSuprimidas: stringType().optional(),
  justificativa: stringType().nullish(),
  deletedAt: dateType().nullish(),
  trocaDiaTrabalhoId: numberType().int().nullish()
});

// src/validators/desconto_dsr.ts
var DescontoDsrSchema = objectType({
  __typename: literalType("DescontoDSR").default("DescontoDSR"),
  id: numberType().int(),
  data: coerce.string(),
  funcionarioId: numberType().int(),
  espelhoPontoId: numberType().int(),
  valor: stringType(),
  createdAt: dateType().optional()
});

// src/validators/dsr.ts
var DsrSchema = objectType({
  __typename: literalType("DSR").default("DSR"),
  id: numberType().int(),
  data: coerce.string(),
  createdAt: dateType().optional(),
  funcionarioId: numberType().int(),
  espelhoPontoId: numberType().int()
});

// src/validators/sobreaviso.ts
var SobreavisoSchema = objectType({
  __typename: literalType("Sobreaviso").default("Sobreaviso"),
  id: numberType().int(),
  empresaId: numberType().int(),
  funcionarioId: numberType().int(),
  data: coerce.string().transform(toDate),
  horarioInicial: stringType(),
  horarioFinal: stringType(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/tabela_horario_funcionario.ts
var TabelaHorarioFuncionarioSchema = objectType({
  __typename: literalType("TabelaHorarioFuncionario").default("TabelaHorarioFuncionario"),
  id: numberType().int(),
  empresaId: numberType().int(),
  funcionarioId: numberType().int(),
  dtInicial: coerce.string().transform(toDate),
  dtFinal: coerce.string().transform(toDate).nullish(),
  createdAt: dateType().optional(),
  tabelaHorarioId: numberType().int()
});

// src/validators/troca_tabela_automatica.ts
var TrocaTabelaAutomaticaSchema = objectType({
  __typename: literalType("TrocaTabelaAutomatica").default("TrocaTabelaAutomatica"),
  id: numberType().int(),
  empresaId: numberType().int(),
  funcionarioId: numberType().int(),
  tabelaHorarioId: numberType().int(),
  clienteId: numberType().int(),
  dataInicial: coerce.string().transform(toDate),
  dataFinal: coerce.string().transform(toDate).nullish(),
  tipoRepeticao: nativeEnumType(TipoRepeticao),
  every: coerce.number().int().min(0).max(999).optional(),
  repeticaoSemanalDia: coerce.number().min(0).max(6).int(),
  repeticaoMensalOpcao: nativeEnumType(RepeticaoMensalOpcao),
  duracaoRepeticao: coerce.number().min(1).max(999).int(),
  tipoDuracaoRepeticao: nativeEnumType(TipoRepeticao),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/troca_dia_trabalho.ts
var TrocaDiaTrabalhoSchema = objectType({
  __typename: literalType("TrocaDiaTrabalho").default("TrocaDiaTrabalho"),
  id: numberType().int(),
  trabalha: coerce.string().transform(toDate),
  folga: coerce.string().transform(toDate),
  empresaId: numberType().int(),
  funcionarioId: numberType().int(),
  tabelaHorarioId: numberType().int().nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/interjornada.ts
var InterjornadaSchema = objectType({
  __typename: literalType("Interjornada").default("Interjornada"),
  id: numberType().int(),
  data: dateType(),
  funcionarioId: numberType().int(),
  quantidadeHoras: stringType(),
  createdAt: dateType().optional()
});

// src/validators/supervisor.ts
var SupervisorSchema = objectType({
  __typename: literalType("Supervisor").default("Supervisor"),
  id: numberType().int(),
  usuarioId: numberType().int().nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  nome: stringType(),
  cpf: stringType().refine(isCPF, {
    message: "CPF inv\xE1lido"
  }).transform(removeMask).nullish()
});

// src/validators/supervisor_centro_custos.ts
var SupervisorCentroCustosSchema = objectType({
  __typename: literalType("SupervisorCentroCustos").default("SupervisorCentroCustos"),
  id: numberType().int(),
  supervisorId: numberType().int(),
  centroCustoId: numberType().int(),
  createdAt: dateType().optional()
});

// src/validators/supervisor_locais.ts
var SupervisorLocaisSchema = objectType({
  __typename: literalType("SupervisorLocais").default("SupervisorLocais"),
  id: numberType().int(),
  supervisorId: numberType().int(),
  localId: numberType().int(),
  createdAt: dateType().optional()
});

// src/validators/supervisor_empresas.ts
var SupervisorEmpresasSchema = objectType({
  __typename: literalType("SupervisorEmpresas").default("SupervisorEmpresas"),
  id: numberType().int(),
  supervisorId: numberType().int(),
  empresaId: numberType().int(),
  createdAt: dateType().optional()
});

// src/validators/saldo_horas.ts
var literalSchema4 = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
var jsonSchema4 = lazyType(() => unionType([
  literalSchema4,
  arrayType(jsonSchema4),
  recordType(jsonSchema4)
]));
var SaldoHorasSchema = objectType({
  __typename: literalType("SaldoHoras").default("SaldoHoras"),
  id: numberType().int(),
  funcionarioId: numberType().int(),
  empresaId: numberType().int(),
  competencia: stringType(),
  faltas: stringType(),
  implantacao: nativeEnumType(SN2).optional(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  horasExtras: stringType(),
  saldoAnteriorId: numberType().int().nullish(),
  porcentagemHorasExtras: jsonSchema4,
  porcentagemHorasExtrasNoturnas: jsonSchema4.optional(),
  faltasIntegrais: stringType().optional(),
  faltasParciais: stringType().optional(),
  faltasInjustificadas: stringType().optional(),
  faltasJustificadas: stringType().optional()
});

// src/validators/saldo_horas_diario.ts
var literalSchema5 = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
var jsonSchema5 = lazyType(() => unionType([
  literalSchema5,
  arrayType(jsonSchema5),
  recordType(jsonSchema5)
]));
var SaldoHorasDiarioSchema = objectType({
  __typename: literalType("SaldoHorasDiario").default("SaldoHorasDiario"),
  id: numberType().int(),
  funcionarioId: numberType().int(),
  empresaId: numberType().int(),
  competencia: stringType(),
  data: stringType(),
  espelhoPontoId: numberType().int(),
  extras: stringType().optional(),
  faltas: stringType().optional(),
  faltasNaoCompensaveisMinutos: numberType().int().optional(),
  porcentagemHorasExtras: jsonSchema5.optional(),
  saldoDiaMinutos: numberType().int().optional(),
  acumuladoMesMinutos: numberType().int().optional(),
  acumuladoBancoMinutos: numberType().int().optional(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/historico_importacao.ts
var literalSchema6 = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
var jsonSchema6 = lazyType(() => unionType([
  literalSchema6,
  arrayType(jsonSchema6),
  recordType(jsonSchema6)
]));
var HistoricoImportacaoSchema = objectType({
  __typename: literalType("HistoricoImportacao").default("HistoricoImportacao"),
  id: numberType().int(),
  cod: stringType(),
  data: coerce.string().transform(toDate),
  hora: stringType(),
  descricao: stringType(),
  progresso: numberType().int(),
  log: jsonSchema6,
  status: nativeEnumType(Status2),
  empresaId: numberType().int(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/historico_calculo.ts
var HistoricoCalculoSchema = objectType({
  __typename: literalType("HistoricoCalculo").default("HistoricoCalculo"),
  id: numberType().int(),
  cod: stringType(),
  data: coerce.string().transform(toDate),
  hora: stringType(),
  progresso: numberType().int(),
  status: nativeEnumType(Status2),
  empresaId: numberType().int().nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  competencia: stringType(),
  pdfProcessado: booleanType().nullish().optional()
});

// src/validators/historico_calculo_logs.ts
var literalSchema7 = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
var jsonSchema7 = lazyType(() => unionType([
  literalSchema7,
  arrayType(jsonSchema7),
  recordType(jsonSchema7)
]));
var HistoricoCalculoLogsSchema = objectType({
  __typename: literalType("HistoricoCalculoLogs").default("HistoricoCalculoLogs"),
  id: numberType().int(),
  historicoCalculoId: numberType().int(),
  log: jsonSchema7,
  status: nativeEnumType(HistoricoLogStatus),
  createdAt: dateType().optional()
});

// src/validators/historico_calculo_empresa.ts
var HistoricoCalculoEmpresaSchema = objectType({
  __typename: literalType("HistoricoCalculoEmpresa").default("HistoricoCalculoEmpresa"),
  id: numberType().int(),
  historicoId: numberType().int(),
  empresaId: numberType().int(),
  createdAt: dateType().optional()
});

// src/validators/fechamento_competencia.ts
var FechamentoCompetenciaSchema = objectType({
  __typename: literalType("FechamentoCompetencia").default("FechamentoCompetencia"),
  id: numberType().int(),
  competencia: stringType(),
  dataFechamento: coerce.string().transform(toDate).nullish(),
  horaFechamento: stringType().nullish(),
  justificativa: stringType().max(190),
  status: nativeEnumType(StatusCompetencia2),
  usuarioId: numberType().int(),
  empresaId: numberType().int().nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/abertura_competencia.ts
var AberturaCompetenciaSchema = objectType({
  __typename: literalType("AberturaCompetencia").default("AberturaCompetencia"),
  id: numberType().int(),
  competencia: stringType(),
  dataAbertura: coerce.string().transform(toDate).nullish(),
  horaAbertura: stringType().nullish(),
  justificativa: stringType().max(190),
  status: nativeEnumType(StatusCompetencia2),
  usuarioId: numberType().int(),
  empresaId: numberType().int().nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/pagamento_horas.ts
var literalSchema8 = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
var jsonSchema8 = lazyType(() => unionType([
  literalSchema8,
  arrayType(jsonSchema8),
  recordType(jsonSchema8)
]));
var PagamentoHorasSchema = objectType({
  __typename: literalType("PagamentoHoras").default("PagamentoHoras"),
  id: numberType().int(),
  funcionarioId: numberType().int(),
  empresaId: numberType().int(),
  competencia: stringType(),
  horas: stringType(),
  faltas: stringType(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  porcentagens: jsonSchema8
});

// src/validators/vale_alimentacao.ts
var ValeAlimentacaoSchema = objectType({
  __typename: literalType("ValeAlimentacao").default("ValeAlimentacao"),
  id: numberType().int(),
  empresaId: numberType().int(),
  valorVale: coerce.number(),
  minimoHorasValorIntegral: coerce.number().int(),
  maximoHorasValorIntegral: coerce.number().int(),
  porcentagemValorMinimo: coerce.number(),
  porcentagemValorMaximo: coerce.number(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/compensacoes.ts
var CompensacoesSchema = objectType({
  __typename: literalType("Compensacoes").default("Compensacoes"),
  id: numberType().int(),
  espelhoPontoId: numberType().int(),
  empresaId: numberType().int(),
  funcionarioId: numberType().int(),
  data: stringType(),
  competencia: stringType(),
  porcentagem: stringType().max(5, {
    message: "M\xE1ximo 5 caracteres"
  }),
  horas: stringType(),
  createdAt: dateType().optional(),
  compensacao: numberType().int().optional(),
  destinoId: numberType().int().nullish(),
  pagamentoHorasId: numberType().int().nullish(),
  faltaCompetencia: stringType().nullish(),
  updatedAt: dateType().optional()
});

// src/validators/compensacao_manual_destino.ts
var CompensacaoManualDestinoSchema = objectType({
  __typename: literalType("CompensacaoManualDestino").default("CompensacaoManualDestino"),
  id: numberType().int(),
  compensacaoManualId: numberType().int(),
  data: dateType(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/compensacao_manual.ts
var CompensacaoManualSchema = objectType({
  __typename: literalType("CompensacaoManual").default("CompensacaoManual"),
  id: numberType().int(),
  tipo: nativeEnumType(TipoCompensacaoManual2),
  empresaId: numberType().int(),
  funcionarioId: numberType().int(),
  calculoId: numberType().int().nullish(),
  data: dateType(),
  competencia: stringType(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/historico_exportacao_folha_pagamento.ts
var literalSchema9 = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
var jsonSchema9 = lazyType(() => unionType([
  literalSchema9,
  arrayType(jsonSchema9),
  recordType(jsonSchema9)
]));
var HistoricoExportacaoFolhaPagamentoSchema = objectType({
  __typename: literalType("HistoricoExportacaoFolhaPagamento").default("HistoricoExportacaoFolhaPagamento"),
  id: numberType().int(),
  pagamentos: jsonSchema9.nullish(),
  empresaId: numberType().int(),
  competencia: stringType(),
  arquivo: stringType(),
  descricao: stringType(),
  createdAt: dateType().optional(),
  usuarioId: numberType().int()
});

// src/validators/alteracao.ts
var literalSchema10 = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
var jsonSchema10 = lazyType(() => unionType([
  literalSchema10,
  arrayType(jsonSchema10),
  recordType(jsonSchema10)
]));
var AlteracaoSchema = objectType({
  __typename: literalType("Alteracao").default("Alteracao"),
  id: numberType().int(),
  diff: jsonSchema10,
  motivo: stringType().nullish(),
  usuarioId: numberType().int(),
  createdAt: dateType().optional(),
  objeto: stringType().optional(),
  abonoId: numberType().int().nullish(),
  afastamentoId: numberType().int().nullish(),
  compensacaoDiaId: numberType().int().nullish(),
  registroId: numberType().int().nullish(),
  empresaId: numberType().int().nullish(),
  funcionarioId: numberType().int().nullish(),
  faltaId: numberType().int().nullish(),
  perfilPermissaoId: numberType().int().nullish(),
  tabelaHorarioId: numberType().int().nullish(),
  regraCalculoId: numberType().int().nullish(),
  espelhoPontoId: numberType().int().nullish()
});

// src/validators/relatorio_ajuste.ts
var literalSchema11 = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
var jsonSchema11 = lazyType(() => unionType([
  literalSchema11,
  arrayType(jsonSchema11),
  recordType(jsonSchema11)
]));
var RelatorioAjusteSchema = objectType({
  __typename: literalType("RelatorioAjuste").default("RelatorioAjuste"),
  id: numberType().int(),
  hash: stringType(),
  empresaId: numberType().int(),
  arquivo: stringType(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  request: jsonSchema11,
  competencia: stringType(),
  assinadoEm: dateType().nullish(),
  funcionarioId: numberType().int()
});

// src/validators/filtro.ts
var literalSchema12 = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
var jsonSchema12 = lazyType(() => unionType([
  literalSchema12,
  arrayType(jsonSchema12),
  recordType(jsonSchema12)
]));
var FiltroSchema = objectType({
  __typename: literalType("Filtro").default("Filtro"),
  id: numberType().int(),
  nome: stringType().max(40),
  usuarioId: numberType().int(),
  items: jsonSchema12,
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/modulo_cliente.ts
var ModuloClienteSchema = objectType({
  __typename: literalType("ModuloCliente").default("ModuloCliente"),
  id: numberType().int(),
  clienteId: numberType().int(),
  modulo: stringType(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/perfil_permissao.ts
var PerfilPermissaoSchema = objectType({
  __typename: literalType("PerfilPermissao").default("PerfilPermissao"),
  id: numberType().int(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  clienteId: numberType().int(),
  nome: stringType().min(1, "Obrigat\xF3rio")
});

// src/validators/modulo_permissao.ts
var ModuloPermissaoSchema = objectType({
  __typename: literalType("ModuloPermissao").default("ModuloPermissao"),
  id: numberType().int(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  perfilPermissaoId: numberType().int(),
  subject: stringType().min(1, "Obrigat\xF3rio"),
  create: booleanType().optional(),
  read: booleanType().optional(),
  update: booleanType().optional(),
  delete: booleanType().optional()
});

// src/validators/excecoes_permissao_ocorrencia.ts
var ExcecoesPermissaoOcorrenciaSchema = objectType({
  __typename: literalType("ExcecoesPermissaoOcorrencia").default("ExcecoesPermissaoOcorrencia"),
  id: numberType().int(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  perfilPermissaoId: numberType().int(),
  ocorrenciaId: numberType().int()
});

// src/validators/reajuste_anual.ts
var ReajusteAnualSchema = objectType({
  __typename: literalType("ReajusteAnual").default("ReajusteAnual"),
  ano: numberType().int(),
  janeiro: numberType().optional(),
  fevereiro: numberType().optional(),
  marco: numberType().optional(),
  abril: numberType().optional(),
  maio: numberType().optional(),
  junho: numberType().optional(),
  julho: numberType().optional(),
  agosto: numberType().optional(),
  setembro: numberType().optional(),
  outubro: numberType().optional(),
  novembro: numberType().optional(),
  dezembro: numberType().optional()
});

// src/validators/falta_cadastrada.ts
var FaltaCadastradaSchema = objectType({
  __typename: literalType("FaltaCadastrada").default("FaltaCadastrada"),
  id: numberType().int(),
  funcionarioId: numberType().int(),
  empresaId: numberType().int(),
  data: dateType(),
  justificativa: stringType().max(190).nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  deletedAt: dateType().nullish(),
  fileUrl: stringType().nullish(),
  tempo: stringType().nullish(),
  origem: numberType().int().optional()
});

// src/validators/escala_trabalho.ts
var EscalaTrabalhoSchema = objectType({
  __typename: literalType("EscalaTrabalho").default("EscalaTrabalho"),
  id: numberType().int(),
  trabalha: stringType(),
  folga: stringType(),
  descricao: stringType(),
  clienteId: numberType().int(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  tipo: nativeEnumType(TipoEscalaTrabalho),
  horaExtraNoFeriado: nativeEnumType(SN2).nullish().optional()
});

// src/validators/escalas_trabalho_funcionario.ts
var EscalasTrabalhoFuncionarioSchema = objectType({
  __typename: literalType("EscalasTrabalhoFuncionario").default("EscalasTrabalhoFuncionario"),
  id: numberType().int(),
  escalaTrabalhoId: numberType().int(),
  funcionarioId: numberType().int(),
  dtInicial: coerce.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Data inv\xE1lida"),
  dtFinal: coerce.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Data inv\xE1lida").nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional()
});

// src/validators/folga.ts
var FolgaSchema = objectType({
  __typename: literalType("Folga").default("Folga"),
  id: numberType().int(),
  clienteId: numberType().int(),
  escalaId: numberType().int(),
  createdAt: dateType().optional(),
  data: dateType(),
  funcionarioId: numberType().int(),
  calculoId: numberType().int()
});

// src/validators/certificado.ts
var CertificadoSchema = objectType({
  __typename: literalType("Certificado").default("Certificado"),
  id: numberType().int(),
  nome: stringType(),
  tipo: nativeEnumType(TipoCertificado).optional(),
  filename: stringType(),
  senhaCriptografada: stringType(),
  assinanteNome: stringType().nullish(),
  assinanteDocumento: stringType().nullish(),
  subject: stringType().nullish(),
  issuer: stringType().nullish(),
  expiracao: dateType().nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  deletedAt: dateType().nullish()
});

// src/validators/api_client.ts
var literalSchema13 = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
var jsonSchema13 = lazyType(() => unionType([
  literalSchema13,
  arrayType(jsonSchema13),
  recordType(jsonSchema13)
]));
var ApiClientSchema = objectType({
  __typename: literalType("ApiClient").default("ApiClient"),
  id: numberType().int(),
  clienteId: numberType().int(),
  nome: stringType(),
  clientId: stringType(),
  secretHash: stringType(),
  scopes: jsonSchema13,
  rateLimitRpm: numberType().int().optional(),
  ativo: nativeEnumType(SN2).optional(),
  ultimoAcessoEm: dateType().nullish(),
  createdAt: dateType().optional(),
  updatedAt: dateType().optional(),
  deletedAt: dateType().nullish()
});

// src/validators/saldo_horas_public_view.ts
var SaldoHorasPublicViewSchema = objectType({
  __typename: literalType("SaldoHorasPublicView").default("SaldoHorasPublicView"),
  id: numberType().int(),
  clienteId: numberType().int(),
  empresaId: numberType().int(),
  funcionarioId: numberType().int(),
  funcionarioMatricula: numberType().int(),
  funcionarioNome: stringType(),
  competencia: stringType(),
  data: dateType(),
  extrasMinutos: numberType().int(),
  faltasMinutos: numberType().int(),
  faltasNaoCompensaveisMinutos: numberType().int(),
  saldoDiaMinutos: numberType().int(),
  acumuladoMesMinutos: numberType().int(),
  acumuladoBancoMinutos: numberType().int()
});

// src/validators/registro_public_view.ts
var RegistroPublicViewSchema = objectType({
  __typename: literalType("RegistroPublicView").default("RegistroPublicView"),
  id: numberType().int(),
  clienteId: numberType().int(),
  empresaId: numberType().int(),
  funcionarioId: numberType().int(),
  funcionarioMatricula: numberType().int(),
  funcionarioNome: stringType(),
  data: dateType(),
  hora: stringType(),
  origem: numberType().int(),
  nsr: numberType().int().nullish(),
  localId: numberType().int().nullish(),
  localNome: stringType().nullish(),
  statusAprovacao: nativeEnumType(StatusAprovacao2),
  dentroCerca: nativeEnumType(SN2).nullish(),
  saidaDiaAnterior: nativeEnumType(SN2).nullish(),
  entradaDiaSeguinte: nativeEnumType(SN2),
  criadoEm: dateType()
});

// src/validators/calculo_public_view.ts
var CalculoPublicViewSchema = objectType({
  __typename: literalType("CalculoPublicView").default("CalculoPublicView"),
  id: numberType().int(),
  clienteId: numberType().int(),
  empresaId: numberType().int(),
  funcionarioId: numberType().int(),
  funcionarioMatricula: numberType().int(),
  funcionarioNome: stringType(),
  competencia: stringType(),
  data: dateType(),
  horasTrabalhadasMinutos: numberType().int(),
  horasExtraMinutos: numberType().int(),
  faltasMinutos: numberType().int(),
  adicionalNoturnoMinutos: numberType().int(),
  sobreavisoMinutos: numberType().int(),
  horasAbonadasMinutos: numberType().int(),
  horasSuprimidasMinutos: numberType().int()
});

// src/validators/inconsistencia_public_view.ts
var literalSchema14 = unionType([
  stringType(),
  numberType(),
  booleanType()
]);
var jsonSchema14 = lazyType(() => unionType([
  literalSchema14,
  arrayType(jsonSchema14),
  recordType(jsonSchema14)
]));
var InconsistenciaPublicViewSchema = objectType({
  __typename: literalType("InconsistenciaPublicView").default("InconsistenciaPublicView"),
  id: numberType().int(),
  clienteId: numberType().int(),
  empresaId: numberType().int(),
  empresaNome: stringType(),
  funcionarioId: numberType().int(),
  codigo: numberType().int(),
  funcionarioNome: stringType(),
  competencia: stringType(),
  data: dateType(),
  horasExtra: stringType(),
  faltas: stringType(),
  horasTrabalhadas: stringType(),
  horasSuprimidas: stringType(),
  horasInterjornada: stringType().nullish(),
  ent1: stringType().nullish(),
  sai1: stringType().nullish(),
  ent2: stringType().nullish(),
  sai2: stringType().nullish(),
  ent3: stringType().nullish(),
  sai3: stringType().nullish(),
  ent4: stringType().nullish(),
  sai4: stringType().nullish(),
  ent5: stringType().nullish(),
  sai5: stringType().nullish(),
  abono: jsonSchema14.nullish(),
  afastamento: jsonSchema14.nullish()
});

// src/validators/funcionario_public_view.ts
var FuncionarioPublicViewSchema = objectType({
  __typename: literalType("FuncionarioPublicView").default("FuncionarioPublicView"),
  id: numberType().int(),
  clienteId: numberType().int(),
  empresaId: numberType().int(),
  empresaNome: stringType(),
  matricula: numberType().int(),
  matriculaFolha: numberType().int().nullish(),
  nome: stringType(),
  cpf: stringType().nullish(),
  pis: stringType(),
  funcao: stringType(),
  sexo: nativeEnumType(Sexo2).nullish(),
  dtAdmissao: dateType().nullish(),
  dtRescisao: dateType().nullish(),
  modalidadeContratacao: nativeEnumType(ModalidadeContratacao),
  horarioNoturno: nativeEnumType(SN2),
  centroCustoId: numberType().int().nullish(),
  centroCustoNome: stringType().nullish(),
  centroCustoDtInicial: dateType().nullish(),
  centroCustoDtFinal: dateType().nullish(),
  tabelaHorarioId: numberType().int().nullish(),
  tabelaHorarioNome: stringType().nullish(),
  jornadaDtInicial: dateType().nullish(),
  jornadaDtFinal: dateType().nullish()
});

// src/validators/funcionario_local_public_view.ts
var FuncionarioLocalPublicViewSchema = objectType({
  __typename: literalType("FuncionarioLocalPublicView").default("FuncionarioLocalPublicView"),
  id: stringType(),
  clienteId: numberType().int(),
  empresaId: numberType().int(),
  funcionarioId: numberType().int(),
  localId: numberType().int(),
  localNome: stringType()
});
export {
  ABONO,
  AFASTAMENTO,
  CALCULO,
  COMPENSACAO,
  Conexao,
  CsvMapper,
  DEFER_SYMBOL,
  Defer,
  DifferentHeadersError,
  EVENTS,
  FUNCIONARIO,
  LayoutFolha,
  Left,
  Maybe,
  OpcoesExportacaoFolha,
  OrigemFaltaCadastrada,
  REGISTRO,
  Right,
  SCOPES_CONHECIDOS,
  SN,
  Sexo,
  Status,
  StatusAprovacao,
  StatusCompetencia,
  TipoCliente,
  TipoCompensacaoDia,
  TipoCompensacaoManual,
  TipoDescontoDSR,
  TipoOcorrencia,
  TipoSaldo,
  WrongTypeError,
  bancoAtivo,
  cacheKey,
  compactarJornada,
  defer,
  detectarInconsistencias,
  helpers_exports as helpers,
  invariant,
  isScope,
  left,
  listenerEncoded,
  mapAjustes,
  queryParamsToRecord,
  recordToQueryParams,
  right,
  validators_exports as schema,
  temFiltroInconsistencia,
  types,
  validators_exports as zod
};
//# sourceMappingURL=index.js.map